{
  "modelResources": {
    "library": "Resource library",
    "select": "Select",
    "selectOrCreate": "Select or create",
    "unavailable": "Resource creation is unavailable for this model.",
    "elementMedia": "Element media",
    "frontalImage": "Front image (required)",
    "otherImages": "Other images (required)",
    "elementVideo": "Element video (required)",
    "imageRequirements": "Upload images or paste publicly accessible image URLs. Provide 1 front image and 1–3 different angle or detail images. JPG / JPEG / PNG, up to 10 MB each, at least 300 pixels on each side, aspect ratio 1:2.5–2.5:1.",
    "videoRequirements": "Upload a video or paste a publicly accessible video URL. Provide 1 MP4 / MOV, 3–8 seconds, 1080P, 16:9 or 9:16, up to 200 MB. The video must show a realistic humanoid; human speech triggers voice customization and binds the voice to the element.",
    "create_element": "Create element",
    "create_voice": "Create voice",
    "myResources": "My resources",
    "officialResources": "Official resources",
    "empty": "No resources yet",
    "elements": "Element management",
    "voices": "Voice management",
    "previewOnly": "Currently unavailable. You can still view the parameters.",
    "failed": "Resource operation failed"
  },
  "voiceDesign": {
    "saveTitle": "Save a private voice",
    "preview": "Select a preview",
    "previewNumber": "Preview {{count}}",
    "name": "Voice name",
    "save": "Save voice",
    "saving": "Saving…",
    "saveFailed": "Could not save the voice.",
    "slotPrice": "{{amount}} for 30 days. Preview generation is billed separately.",
    "priceUnavailable": "Voice slot pricing is unavailable.",
    "expires": "Expires {{date}}",
    "loadFailed": "Could not load private voices."
  },
  "nativeStudio": {
    "path": "Path parameters",
    "query": "Query parameters",
    "body": "Request parameters",
    "required": "Enter {{field}}.",
    "invalidFiles": "Select local files for {{field}}.",
    "fileNotJson": "Select {{field}} using the file control, not a file URL in JSON.",
    "fileLimit": "{{field}} supports at most {{count}} files.",
    "maxFiles": "At most {{count}} files",
    "scalar": "{{field}} must be text, a number, or a boolean.",
    "invalidPath": "Invalid endpoint path.",
    "saving": "Loading the result and saving images…",
    "readRetrying": "Image records are temporarily unavailable. Retrying automatically. The original response is still available in JSON; do not generate again.",
    "saveFailed": "Image persistence failed. The original response is still available in JSON."
  },
  "channelSupply": {
    "degraded": "Degraded",
    "form": "Channel supply settings",
    "saveFailed": "Could not save supply",
    "costLabel": "Channel cost",
    "targetHelp": "The channel and upstream model ID determine the request destination.",
    "chooseChannel": "Select a compatible channel",
    "channelLocked": "The channel cannot be changed after import. Add a new supply to use another channel.",
    "compatibleChannels": "{{count}} compatible channels. Confirm that the channel has access to this model before connecting it.",
    "noChannels": "No compatible channels.",
    "upstreamId": "Upstream model ID",
    "upstreamIdPlaceholder": "The model ID accepted by the channel",
    "maxActiveJobs": "Async concurrency limit for this channel model",
    "maxActiveJobsPlaceholder": "Blank means unlimited",
    "maxActiveJobsHelp": "Applies only to this channel model. The channel-wide limit still applies.",
    "invalidMaxActiveJobs": "The concurrency limit must be a positive integer",
    "channelInactive": "The upstream channel is {{status}}. This supply will not receive requests even if enabled.",
    "coverage": "Protocols covered by this channel",
    "coverageHelp": "Select protocols the channel supports, then set primary routes and weights. Primary routes take precedence; at the same priority, direct routes are preferred before weighted routing.",
    "coverProtocol": "Connect {{protocol}}",
    "legacy": "Legacy protocol · existing routes only",
    "passthrough": "Passthrough",
    "taskAdapter": "Task adapter",
    "bridge": "Bridge → {{protocol}}",
    "providersOnly": "Only available for {{providers}}",
    "upstreamPath": "Upstream path",
    "protocolPath": "{{protocol}} upstream path",
    "pathPlaceholder": "Path relative to the Base URL",
    "routeStatus": "Route status",
    "protocolStatus": "{{protocol}} route status",
    "protocolPrimary": "{{protocol}} primary route",
    "weight": "Weight",
    "protocolWeight": "{{protocol}} weight",
    "directHelp": "Declare direct upstream support without a platform bridge",
    "enabledAfterSave": "Enabled after saving",
    "notDeclared": "Not declared",
    "noProtocols": "No protocols are available for this model.",
    "mappingOnly": "The supply is enabled, but no route is active. Enable at least one endpoint route.",
    "primaryWarning": "Each endpoint has one primary route. After saving, the primary routes of {{holders}} for the affected endpoints will become backups.",
    "costHelp": "Internal costs are used to estimate selling prices and margins. You can maintain them later.",
    "maintainCost": "Maintain internal cost now",
    "costSource": "Cost source",
    "costSourcePlaceholder": "Contract, quote, or channel documentation",
    "costRules": "Cost pricing rules",
    "costRulesHelp": "Each rule describes a billing condition, such as per 1M tokens or per second of video. Use advanced JSON mode for complex conditions.",
    "saveHelp": "Changes take effect after saving",
    "newSaveHelp": "Routes and weights can be adjusted after saving",
    "saving": "Saving…",
    "save": "Save supply"
  },
  "modelEndpoints": {
    "intro": "Review the provider-native contract and the platform's public endpoints.",
    "nativeContract": "Provider-native contract",
    "codeDefinition": "Code definition",
    "nativeContractHelp": "The provider request and response contract used for integration review and adaptation. Only protocols listed as public endpoints are directly callable.",
    "channels": "Available channels: {{count}}",
    "addresses": "Endpoint URLs",
    "request": "Request",
    "stream": "Streaming audio",
    "officialDocumentation": "View official parameter documentation",
    "empty": "No public endpoints configured"
  },
  "modelIdentity": {
    "intro": "View the model name, version and public Model ID; manage aliases and listing settings.",
    "legacyIntro": "This model is no longer in the current catalog. Existing records are retained.",
    "edit": "Edit listing settings",
    "aliases": "Model ID aliases",
    "aliasesPlaceholder": "Old ID, short ID",
    "aliasesHelp": "Each alias resolves to the same model as the primary Model ID for legacy IDs or shorter names.",
    "aliasPlaceholder": "For example, old-model-id",
    "aliasItem": "Model ID alias {{index}}",
    "addAlias": "Add alias",
    "manageAliases": "Manage aliases",
    "removeAlias": "Remove alias {{index}}",
    "recommendation": "Recommendation",
    "feature": "Feature this model",
    "saveHelp": "Save aliases and listing settings without changing model parameters.",
    "saving": "Saving…",
    "saveFailed": "Could not save listing settings",
    "family": "Model family",
    "registryKey": "Internal registry key",
    "summaryFallback": "{{model}} supports {{operation}}."
  },
  "adminModels": {
    "endpointLabels": {
      "托管任务": "Nexra Task API"
    },
    "description": "Manage model listings, protocol parameters, channels and pricing.",
    "search": "Search models",
    "searchPlaceholder": "Public Model ID, aliases, endpoints or developer",
    "allChannels": "All channels",
    "noDeveloper": "No developer or family",
    "publicApi": "Public API",
    "noEndpoints": "No public endpoints",
    "aliasCount": "Aliases: {{count}}",
    "typeCapability": "Type & capabilities",
    "supply": "Channel supply",
    "channelsCount": "Upstream channels: {{count}}",
    "moreChannels": "{{count}} more",
    "noChannels": "No channels connected",
    "costCoverage": "Cost configured: {{priced}}/{{total}}",
    "view": "View and manage",
    "empty": "No matching models",
    "page": "Page {{page}} · Models: {{count}}",
    "back": "← Back to model catalog",
    "openPublic": "Open in model catalog ↗",
    "publicId": "Public Model ID",
    "quickSettings": "Model quick settings",
    "enable": "Enable model",
    "enableHelp": "Allow requests; callable endpoints, channels and billing configuration are still required.",
    "publish": "Publish model",
    "publicHelp": "Control public visibility without enabling the model.",
    "feature": "Feature model",
    "featureHelp": "Feature this model without enabling or publishing it.",
    "unfeatureHelp": "Remove from featured without changing availability or visibility.",
    "protocols": "Public endpoint protocols",
    "protocolCount": "Model-declared protocols: {{count}}",
    "unconfigured": "Not configured",
    "availabilityHelp": "Callable endpoint counts reflect endpoint, channel, routing and effective sale price configuration, not real-time upstream availability.",
    "apiReadiness": "API readiness",
    "callableRatio": "{{callable}} / {{declared}} endpoints callable",
    "nativeAccess": "Native API",
    "taskAccess": "Nexra Task",
    "developerFact": "Developer: {{value}}",
    "typeFact": "Type: {{value}}",
    "versionFact": "Version: {{value}}",
    "familyFact": "Family: {{value}}",
    "currentPrices": "Current prices",
    "perPricingUnit": "per {{unit}}",
    "morePriceRules": " · {{count}} more",
    "requests30d": "Requests · 30 days",
    "successRate": "{{value}} success",
    "usageUnavailable": "Usage statistics unavailable",
    "supplyChannels": "Supply channels",
    "noSupply": "No schedulable channels",
    "supplyReadiness": "Supply & routing",
    "availableChannels": "Available channels: {{count}}",
    "endpointCoverage": "{{covered}} / {{total}} endpoints covered",
    "commercialReadiness": "Pricing & cost",
    "salePriceActive": "Public price is active",
    "salePriceMissing": "No effective public price",
    "priceCoverage": "Official references: {{official}} · Channel costs: {{priced}}/{{total}}",
    "complete": "Complete",
    "needsConfiguration": "Configuration required",
    "readinessNavigation": "Model readiness summary",
    "openReadiness": "Open {{label}} configuration",
    "disabled": "Model disabled",
    "callable": "Callable endpoints in console: {{count}}",
    "noCallable": "No callable endpoints in console",
    "upstream": "Upstream channels",
    "saveFailed": "Could not save model settings",
    "loading": "Loading model settings…"
  },
  "officialPrice": {
    "validity": "Price validity",
    "ongoing": "Ongoing",
    "promotion": "Limited-time promotion",
    "ongoingHelp": "No end date",
    "promotionHelp": "An end date is required",
    "endsAt": "Promotion end time",
    "endsAtHelp": "This official promotional price expires at this time.",
    "saveFailed": "Save failed",
    "description": "Maintain the current official reference price. Changes take effect immediately after saving.",
    "title": "Edit official price",
    "saveHelp": "The saved price applies to subsequent quotes immediately.",
    "operation": "Applicable operation",
    "source": "Official source or reference link",
    "sourcePlaceholder": "https://... or reference ID",
    "rulesHelp": "Each rule describes a billing condition, such as per 1M tokens or per video second. Use advanced JSON for complex conditions.",
    "promotionFooter": "This price expires when the promotion ends.",
    "ongoingFooter": "Ongoing, with no end date.",
    "saving": "Saving…",
    "save": "Save official price",
    "invalidObjectJson": "Invalid JSON for {{label}}: {{detail}}",
    "parseFailed": "Parsing failed",
    "objectRequired": "{{label}} must be a JSON object"
  },
  "pricingEditor": {
    "invalidJson": "Invalid pricing rule JSON. Correct it below or paste it again.",
    "missingRates": "The pricing rule is missing a rates array. Correct it below or paste it again.",
    "invalidPrice": "Unit price must be a non-negative number",
    "invalidUnit": "Billing unit must be a positive integer",
    "json": "Pricing rule JSON",
    "empty": "No pricing rules yet. Add one below.",
    "rule": "Rule {{index}}",
    "duplicateRule": "Rule {{index}} · Conditions duplicate another rule",
    "copyRule": "Copy rule {{index}}",
    "removeRule": "Remove rule {{index}}",
    "metricLabel": "Rule {{index}} billing metric",
    "priceLabel": "Rule {{index}} unit price",
    "unitLabel": "Rule {{index}} billing unit",
    "rounding": "Billing method",
    "roundingLabel": "Rule {{index}} billing method",
    "proportional": "Actual usage (no rounding)",
    "unknownMetric": "{{metric}} (unlisted)",
    "dimensionLabel": "Rule {{index}} condition {{condition}} dimension",
    "valueLabel": "Rule {{index}} condition {{condition}} value",
    "removeCondition": "Remove condition {{condition}} from rule {{index}}",
    "addCondition": "Add condition",
    "addConditionLabel": "Add condition to rule {{index}}",
    "addRule": "Add pricing rule",
    "scalarHelp": "Number and null conditions retain their original types. Edit their values in advanced JSON.",
    "unitHelp": "Billing unit: token metrics commonly use 1000000 (per 1M tokens); image, video and per-request metrics commonly use 1.",
    "advanced": "Advanced · Edit JSON",
    "jsonHelp": "Paste a complete rule. Once parsed, the form above updates automatically."
  },
  "priceReference": {
    "allManufacturers": "All manufacturers",
    "usd": "US dollar",
    "cny": "Chinese yuan",
    "manufacturer": "Manufacturer",
    "officialList": "Official reference price",
    "allModels": "All models",
    "emptyModels": "No matching models",
    "title": "Model price reference",
    "search": "Search models",
    "searchLabel": "Search model prices",
    "searchPlaceholder": "Enter a name or public model ID",
    "lookup": "View model prices",
    "lookupHelp": "Compare base sale prices, channel costs and official reference prices. Actual charges depend on the price and user discount at invocation; use daily details for that day's charges.",
    "select": "Select a model",
    "loading": "Loading model prices…",
    "failed": "Could not load prices. Refresh to retry.",
    "modelEmpty": "No currently effective prices for this model.",
    "lastRead": "Last successful price read: {{date}} UTC",
    "notRead": "Prices have not been loaded",
    "configure": "View model configuration and pricing sources →",
    "empty": "No currently effective prices",
    "official": "Reference price",
    "cost": "Channel price",
    "multiple": "Sale multiple",
    "equivalent": "CNY equivalent",
    "saleHelp": "Compare sale prices in the channel price currency, or the official currency when no channel price exists. Converted prices are labeled; billing still uses the configured original currency.",
    "equivalentHelp": "CNY equivalent of the comparable USD sale price, for comparison only. Billing uses the original currency.",
    "equivalentFx": "CNY equivalents use 1 USD = {{rate}} CNY, for comparison only.",
    "generalOperation": "All operations",
    "generalChannel": "All channels",
    "invalid": "Invalid pricing rule",
    "invalidHelp": "Cannot read the pricing rule. Check the model configuration.",
    "special": "Special rules",
    "converted": "Converted",
    "currencyUnit": "Currency: {{currency}} · Per {{unit}}",
    "ceil": "Round up",
    "proportional": "Actual quantity",
    "included": "Includes {{quantity}} {{unit}}",
    "original": "Original unit price: {{value}}",
    "currencyHelp": "Upstream currency: {{currency}} · Equivalent at the pricing policy rate: 1 USD = {{rate}} CNY. For current price comparison only; billing retains the original currency and the bound settlement price.",
    "effectiveFrom": "Effective from: {{date}} UTC",
    "effectiveTo": "Effective until: {{date}} UTC",
    "noMultiple": "Multiple —",
    "multipleValue": "{{value}}×",
    "noMultipleHelp": "No unique comparable channel price, no valid exchange rate, or a zero channel price. Different rounding or included quantities cannot be compared directly.",
    "multipleHelp": "Sale price ÷ this row's channel price, with matching units, conditions and rules, rounded to at most 4 decimal places. This is not gross margin.",
    "multipleFx": "Converted at the pricing policy rate: 1 USD = {{rate}} CNY.",
    "condition": "{{label}}: {{value}}",
    "has_reference_image_true": "With reference image",
    "has_reference_image_false": "Without reference image",
    "has_input_video_true": "With input video",
    "has_input_video_false": "Without input video",
    "layer_decomposition_true": "Layered",
    "layer_decomposition_false": "Not layered",
    "with_audio_true": "With audio",
    "with_audio_false": "Without audio"
  },
  "pricingPreview": {
    "discount": "{{value}}% of official",
    "backupCost": "Backup channel cost",
    "metric": "Billing item",
    "condition": "Condition",
    "official": "Official price",
    "primaryCost": "Primary channel cost",
    "sale": "Sale price",
    "vsOfficial": "vs. official",
    "needsFx": "Rate required",
    "perUnit": "Per {{unit}}",
    "editOfficial": "Edit official price",
    "addOfficial": "Add official price",
    "currency": "Display currency",
    "multiplier": "Sales multiplier",
    "multiplierSlider": "Sales multiplier slider",
    "multiplierInput": "Sales multiplier value",
    "quick": "Quick multipliers",
    "settings": "Set quick multipliers",
    "settingsHelp": "Quick multipliers (preview only, not saved)",
    "preset": "Preset {{index}}",
    "presetInput": "Quick multiplier {{index}}",
    "margin": "Gross margin",
    "empty": "No published official price for this operation.",
    "fxHelp": "Compares sale prices in {{currency}} using the policy exchange rate of {{rate}}.",
    "previewHelp": "Prices come from current sale prices. Multiplier changes affect only this preview, not billing.",
    "missingFxHelp": "Sales are billed in CNY. Configure and publish an exchange rate in the pricing policy for cross-currency comparisons.",
    "comparisonHelp": "vs. official: negative is lower, positive is higher.",
    "belowCost": "Sale price below cost",
    "displayedCurrency": "Display currency: {{currency}}",
    "context": "Context {{value}}"
  },
  "adminPricing": {
    "loadFailed": "Pricing policy could not be loaded. Refresh to retry.",
    "managementTitle": "Pricing management",
    "adjust": "Adjust policy",
    "title": "Global sales pricing policy",
    "current": "Published multiplier: ",
    "configuration": "Base sales multiplier",
    "saleFormula": "CNY sale price = converted primary-channel cost × sales multiplier",
    "rateLabel": "USD cost exchange rate",
    "ratePlaceholder": "Operational exchange rate",
    "publishRate": "Save and publish rate",
    "presets": "Multiplier presets",
    "multiplierLabel": "Default sales multiplier",
    "multiplierSlider": "Adjust sales multiplier",
    "atCost": "1.00× (sale equals cost)",
    "halfMargin": "2.00× (about 50% margin)",
    "margin": "Estimated margin based on cost",
    "marginFormula": "Formula: 1 − (1 / multiplier)",
    "publishMultiplier": "Save and publish multiplier",
    "confirmRate": "Publish exchange rate?",
    "confirmMultiplier": "Publish sales multiplier?",
    "confirmHelp": "Sale prices will be recalculated from published primary-channel costs using a {{multiplier}}× multiplier. Publishing updates current prices.",
    "targetMultiplier": "Target sales multiplier",
    "exchangeRate": "USD exchange rate",
    "scope": "Affected scope",
    "scopeValue": "Model billing items with published costs on their primary channel",
    "notConfigured": "Not configured",
    "confirm": "Confirm publication",
    "ratePublished": "Exchange rate published",
    "multiplierPublished": "Sales multiplier published",
    "publishedSummary": "Recalculated and published {{count}} sale prices at {{multiplier}}×"
  },
  "adminWallets": {
    "apply": "Apply filters",
    "frozen": "Wallet frozen",
    "closed": "Closed",
    "title": "Wallets and accounting",
    "total": "Total balance across CNY wallets",
    "search": "Search wallet users",
    "balance": "Total wallet balance",
    "available": "Available balance",
    "updatedAt": "Updated",
    "loading": "Loading wallets…",
    "empty": "No matching wallets",
    "currentBalance": "Current balance",
    "afterBalance": "Balance after credit",
    "balanceLimit": "The resulting balance exceeds the wallet limit. Enter a smaller amount.",
    "offlineHint": "Confirm offline payment (bank transfer, WeChat Pay or Alipay) before posting the credit.",
    "summaryDetail": "Reserved {{reserved}} · Wallets: {{count}}",
    "pageCount": "Wallets on this page: {{count}}",
    "creditDescription": "After confirming offline payment, credit the {{currency}} wallet of {{email}} and create credit and ledger records."
  },
  "adminOperations": {
    "failed": "Operation failed",
    "tryAgain": "Please try again later"
  },
  "adminStorage": {
    "taskApi": "Task API",
    "nativeApi": "Native API",
    "loadFailed": "Could not load storage details. Refresh to retry.",
    "allDispositions": "All dispositions",
    "stored": "Stored",
    "forwarded": "Forwarded",
    "pending": "Pending persistence",
    "failed": "Persistence failed",
    "allKinds": "All types",
    "document": "Document",
    "archive": "Archive",
    "lastDay": "Last 24 hours",
    "lastWeek": "Last 7 days",
    "lastMonth": "Last 30 days",
    "upload": "User upload",
    "imported": "Import",
    "model": "Model",
    "kindPath": "Type / path",
    "surface": "API / source",
    "location": "Storage location",
    "size": "Size",
    "disposition": "Disposition",
    "reference": "Related object",
    "note": "Notes",
    "title": "Storage details",
    "back": "← Call records",
    "languageGateway": "Language gateway (chat / responses / messages / gemini)",
    "languagePolicy": ": Responses are forwarded directly; only the first 64 KB is retained as a troubleshooting preview.",
    "nativeName": "Native API (native)",
    "nativePolicy": ": Responses are forwarded without archiving media or rewriting resource links; call logs retain a limited preview.",
    "taskName": "Task API (nexra-task)",
    "taskPolicy": ": Input and output media are stored; failed persistence is marked for recovery.",
    "publicDomain": "Public domain",
    "objectLimit": "Per-object limit",
    "actualLocation": "The table shows the actual location of each record.",
    "policyTitle": "Response handling and current storage",
    "policySummary": "Language gateway: forwarded · Native API: no media archiving or link rewriting · Task API: media stored",
    "unconfigured": "Storage not configured",
    "loadingConfig": "Loading storage configuration…",
    "anomalies": "Issues",
    "loading": "Loading storage records…",
    "empty": "No storage records match these filters",
    "end": "No more data",
    "filterDisposition": "Filter disposition",
    "mediaKind": "Media type",
    "filterKind": "Filter media type",
    "window": "Reporting window",
    "apply": "Apply filters",
    "detailDescription": "Storage destination and persistence evidence for this response or media object.",
    "detailEyebrow": "Storage relay",
    "internalId": "Internal ID",
    "source": "Source",
    "objectStatus": "Object status",
    "path": "Request path",
    "httpStream": "HTTP / streaming",
    "streaming": "Streaming",
    "nonStreaming": "Non-streaming",
    "storageProvider": "Storage provider",
    "bucket": "Bucket",
    "objectKey": "Object key",
    "publicUrl": "Public URL",
    "notStored": "Why this response is not stored",
    "nativeNotStored": "This Native API call has no media archive; native proxying does not archive media or rewrite resource links.",
    "fullDetails": "View full call details →",
    "persistenceError": "Persistence error",
    "storedDetail": "New objects in window · {{size}}",
    "forwardedDetail": "Native {{native}} · Language gateway {{language}}",
    "issuesDetail": "Pending {{pending}} · Failed {{failed}}",
    "assetTitle": "Media asset {{id}}",
    "requestTitle": "Proxy request {{id}}",
    "pageCount": "Rows on this page: {{count}}",
    "cursorPage": " · Paginated",
    "windowHours": " · Reporting window: {{count}} hours"
  },
  "adminErrorReport": {
    "requestShare": "Share of all requests",
    "nonErrorShare": "Non-error share",
    "periodScope": "Requests received within the period: start inclusive, end exclusive.",
    "cancellationScope": "Cancellations are excluded from call errors.",
    "nonErrorRequests": "Non-error requests",
    "compareFromZero": "vs previous: 0 → {{count}}",
    "comparePoints": "vs previous {{direction}} {{value}} pp",
    "comparePercent": "vs previous {{direction}} {{value}}%",
    "rankHelp": "Ranked by error rate, highest first, then by error count for equal rates.",
    "statusDistribution": "Call anomaly breakdown",
    "statusDistributionHelp": "Shares are based on failures, rejections, delivery failures and cancellations. Cancellations are excluded from the call error rate. Small slices are enlarged for visibility; the figures on the right show the actual shares.",
    "trendHint": "Errors per UTC day and their share of all requests. Cancellations are excluded.",
    "distributionHint": "Anomaly counts and shares for the current filters.",
    "dimensionDistribution": "Anomaly dimension distribution",
    "other": "Other ({{count}} items)",
    "tab": "Error overview",
    "title": "Error overview",
    "failedRequests": "Call errors",
    "failedHelp": "Execution failures, rejections and delivery failures; cancellations are counted separately",
    "failureRate": "Final call error rate",
    "trend": "Error trend",
    "categories": "Billing anomaly categories",
    "share": "Share",
    "firstOccurrence": "First occurrence",
    "lastOccurrence": "Latest occurrence",
    "scopeHelp": "Inspect error causes and affected models and channels, then open the matching records.",
    "cancelled": "Cancelled requests",
    "billingHelp": "Counted independently; a request may have both a call error and a billing anomaly",
    "requestBase": "Out of {{count}} requests in this scope",
    "normalCalls": "{{total}} total · {{normal}} normal",
    "normalRate": "Normal rate {{rate}}",
    "cancelledShare": "{{rate}} of all requests",
    "viewRecords": "View records",
    "errorCode": "Error code",
    "errorCodeSearch": "Enter an exact error code",
    "missingCode": "No error code recorded",
    "clearMissingCode": "No error code · Clear filter",
    "unattributed": "Unassigned",
    "reasons": "Top error causes",
    "topTen": "Top 10 by error count. Shares are calculated against all call errors.",
    "modelRank": "Affected models · Top 10",
    "channelRank": "Affected channels · Top 10",
    "emptyErrors": "No call errors match these filters",
    "emptyCalls": "No call anomalies match these filters",
    "allErrors": "View all call errors",
    "allBilling": "View all billing anomalies",
    "invalidWindow": "The reporting interval cannot exceed 366 days"
  },
  "adminFinance": {
    "shortcutDescription": "Sales, costs and profit",
    "title": "Financial statistics",
    "records": "Cost records",
    "overview": "Financial overview",
    "summary": "Cost analysis",
    "usage": "Usage",
    "knownCost": "Known cost",
    "incompleteCost": "Cost data incomplete",
    "settledCount": "{{count}} settled",
    "salesChange": "Sales change",
    "salesChangeRate": "Sales change rate",
    "salesChangeHint": "Compares all settled CNY sales with the preceding equal-length period. Change = current sales minus previous sales; rate = change divided by previous sales.",
    "noSalesComparison": "No comparable sales",
    "zeroSalesComparison": "Previous sales are zero; rate is not applicable",
    "coverageRate": "Cost coverage rate",
    "coverageRateHint": "Cost-covered records divided by total records, using the same scope as the coverage count.",
    "coverageCount": "Cost-covered records",
    "coveredGross": "Gross profit with covered costs",
    "coveredProfitHint": "Profit from cost-covered records only",
    "coveredMarginHint": "Based on revenue from cost-covered records",
    "profitGrowth": "Gross profit change amount",
    "profitGrowthRate": "Gross profit change rate",
    "previousPeriod": "Versus the preceding equal-length period",
    "noComparison": "No comparable profit",
    "zeroComparison": "Previous profit is zero; rate is not applicable",
    "growthHint": "Compared with the preceding equal-length period. Change = current profit minus previous profit; rate = change divided by the absolute previous profit. Only cost-covered records are included; coverage changes also affect the result.",
    "settledScope": "Settled · CNY",
    "details": {
      "title": "{{name}} · Billing details",
      "names": {
        "product": "Product",
        "kind": "Model purpose"
      },
      "search": {
        "product": "Search product names",
        "model": "Search model names or Model IDs",
        "channel": "Search providers or channel names"
      },
      "complete": "Complete costs",
      "missingCost": "Missing cost",
      "missingRate": "Missing FX rate",
      "allCoverage": "All cost states",
      "coverage": "Cost completeness",
      "settledRequests": "Settled requests",
      "exportRows": "All {{count}} rows matching the submitted search and filters. Amounts are in CNY.",
      "allSeries": "All model series",
      "allKinds": "All model purposes",
      "startDate": "Start date (UTC)",
      "endDate": "End date (UTC)",
      "dateRecords": "Date records",
      "allDates": "All dates",
      "activeDates": "Dates with settlements",
      "empty": "No matching details",
      "total": "Filtered total · {{count}} rows"
    },
    "chartTitles": {
      "product": "Revenue and cost by product",
      "kind": "Revenue and cost by model purpose",
      "model": "Revenue and cost by model version",
      "channel": "Revenue and cost by channel"
    },
    "products": {
      "vibepaper": "VibePaper",
      "starcut": "StarCut",
      "starcat": "StarCat",
      "unattributed": "Unattributed product"
    },
    "kinds": {
      "language": "Text",
      "image": "Image",
      "video": "Video",
      "audio": "Audio",
      "world": "World model",
      "embedding": "Embedding",
      "unknown": "Unclassified purpose"
    },
    "modelFamily": "Model series",
    "unattributedFamily": "Unattributed series",
    "unattributedModel": "Unattributed model",
    "unattributedChannel": "Unattributed channel",
    "modelComparisonHint": "Settled CNY revenue and recorded costs for each model in the selected series and time window. Margins use profit and revenue from the same cost-covered records. Missing costs are not zero.",
    "comparisonHint": "Settled CNY revenue and recorded costs in the selected window. Margins use profit and revenue from the same cost-covered records. All groups are displayed.",
    "productAttributionHint": "Products are provisionally identified by API key name labels. Unattributed records remain included. Missing costs are not zero.",
    "chartKeyboard": "{{title}}. Use arrow keys to browse groups, Home and End for the first and last group, and Escape to hide the tooltip."
  },
  "adminUsage": {
    "userTextSearch": "User ID, email or username",
    "changeDirection": {
      "increase": "Increase",
      "decrease": "Decrease",
      "unchanged": "Unchanged"
    },
    "modelActions": {
      "details": "Model details",
      "noModel": "This summary row does not identify a single model"
    },
    "requestGrowth": "Request growth",
    "requestGrowthRate": "Request growth rate",
    "requestGrowthHint": "Compared with the preceding equal-length period. Growth = current requests minus previous requests; rate = growth divided by previous requests. No rate is shown when the previous count is zero.",
    "noRequestComparison": "No comparable request data",
    "zeroRequestComparison": "Previous request count is zero; growth rate is unavailable",

    "failedRequests": "Failed requests",
    "productRequestsHint": "All requests grouped by product labels in API key names. Requests without labels remain unattributed.",
    "kindRequestsHint": "All request counts grouped by the catalog model purpose.",
    "modelSeriesDistributionHint": "Requests grouped by model series. Gemini includes all Gemini models. Select a series to view its models.",
    "otherModelSeries": "Other series ({{count}})",
    "productRequestCounts": "Requests by product",
    "kindRequestCounts": "Requests by model purpose",
    "channelDistribution": "Channel call distribution",
    "channelDistributionHint": "Request shares by channel. Select a channel to view details.",
    "modelRequestCounts": "Model request counts",
    "channelRequestCounts": "Channel request counts",
    "requestComparisonHint": "Sorted by request count. Select an item to view details.",

    "dailyCalls": "Daily calls",
    "dailyCallsHint": "Compare total and successful requests by day. Failed requests appear only in the tooltip.",
    "successfulRequests": "Successful requests",
    "requestSuccessRate": "Request success rate",
    "statisticsDetails": "Usage details",
    "statisticsDetailsTitle": "{{name}} · Usage details",
    "uncoveredRequests": "Uncovered requests",
    "coveredRequests": "Covered requests",

    "providerId": "Provider ID",
    "requestCapability": "This call",
    "inputFeatures": {
      "text": "Prompt",
      "image": "Image input",
      "video": "Video input",
      "audio": "Audio input",
      "first_frame": "First frame",
      "last_frame": "Last frame",
      "reference_image": "Reference image",
      "reference_video": "Reference video",
      "reference_audio": "Reference audio"
    },
    "totalRequests": "Total requests",
    "bucketHint": "All requests received in this time bucket.",
    "successHint": "Successful API calls and accepted asynchronous tasks. Acceptance does not mean the task finished successfully or was billed.",
    "failureHint": "Failed, cancelled or rejected calls, not billing failures.",
    "billedHint": "A successful settlement exists, including refunded records. Amounts only include successful settlements.",
    "unsettledHint": "Usage exists without a successful settlement. Inspect request details if this persists.",
    "billingFailedHint": "A failed settlement exists. Inspect billing anomalies for the cause.",
    "unpricedHint": "The call succeeded without a matching sales price. Check pricing for the model and action.",
    "usageMissingHint": "The request succeeded but no usage was recorded — an anomaly worth investigating.",
    "usageNotExpectedHint": "The request did not succeed (rejected, failed, cancelled, or still running), so usage is not expected; not an anomaly.",
    "otherRequests": "Other requests",
    "emptyRequests": "No request data for these filters.",
    "modelNameUnavailable": "Model name unavailable",
    "modelDistribution": "Model request distribution",
    "modelDistributionHint": "The eight most used models run from red to cool colors by request rank; the remaining models are gray. Select a slice or name for details.",
    "ratingDistribution": "Billing status distribution",
    "ratingDistributionHint": "The donut shows six mutually exclusive billing statuses. Percentages use all filtered requests; select a slice or status for details. Small slices are enlarged for visibility; the figures on the right show the actual shares.",
    "longDateRange": "The interval exceeds 500 days. Charts and tables only list dates with requests. Narrow the interval for continuous daily data.",
    "noDates": "No dates",
    "usageHit": "With usage",
    "prevPeriod": "Previous period",
    "nextPeriod": "Next period",
    "earlierDates": "Earlier dates",
    "laterDates": "Later dates",
    "noSettlements": "No successfully settled amounts for these filters. Request data remains in the daily table.",
    "dailyDetailsHint": "Newest dates first, up to 30 days per page. Financial amounts are in CNY and only include successful settlements, excluding refunds and failures. Original purchase costs and frozen exchange rates remain in call details and exports.",
    "dailyDetails": "Daily charge details",
    "utcDateHint": "Dates use request receipt time in UTC.",
    "dailyRequestsHint": "All requests received that day, including ongoing requests.",
    "dailySuccessHint": "Actual successes among requests received that day. Asynchronous tasks must finish execution and delivery; acceptance alone is not success.",
    "dailyFailedHint": "Requests that did not actually succeed that day.",
    "failedTasks": "Failed tasks",
    "dailyBilledHint": "Requests with a successful settlement. Refunded records count as billed but are excluded from financial amounts.",
    "dailyInputHint": "Measured input tokens only. Missing values show —, not zero.",
    "dailyOutputHint": "Measured output tokens only. Missing values show —, not zero.",
    "dailySalesHint": "Successfully settled CNY sales, excluding refunds and failed settlements.",
    "dailyCostHint": "Purchase costs converted to CNY using each request's frozen exchange rate. Missing costs or rates are not treated as zero.",
    "dailyGrossHint": "CNY sales minus purchase costs. Requests with missing costs or rates are excluded; incomplete costs yield partial gross profit.",
    "grossCny": "Gross profit",
    "dailyMarginHint": "CNY gross profit divided by sales. Shows — when sales are zero or costs are incomplete.",
    "previousDatePage": "Previous dates",
    "nextDatePage": "Next dates",
    "dualAxisHint": "Request bars use the left axis; token lines use the right axis. Scales are independent, so heights cannot be compared directly.",
    "tokenAxisHint": "Input and output tokens use the right axis. Only measured values are summed; missing values are not zero.",
    "mixedChart": "combined bar and line chart",
    "barChart": "bar chart",
    "emptyDaily": "No daily data for these filters.",
    "inputLineHint": "Measured input tokens only. Missing values show —, not zero.",
    "outputLineHint": "Measured output tokens only. Missing values show —, not zero.",
    "dailyUsage": "Daily usage",
    "requestAxis": "Requests",
    "tokenAxis": "Tokens",
    "dailyUsageHint": "By request receipt date. Totals include ongoing requests. Tokens only include measured values; missing values show —, not zero.",
    "dailyFinance": "Daily revenue and cost (CNY)",
    "dailyFinanceHint": "CNY reporting: sales and purchase costs converted at frozen exchange rates. Successful settlements only.",
    "comparePrev": "vs previous period",
    "dailyPeakLabel": "Peak",
    "dailyPeakSuffix": " ({{day}})",
    "otherModels": "Other models ({{count}})",
    "otherChannels": "Other channels ({{count}})",
    "viewAllInSummary": "View all in usage summary",
    "viewModel": "View requests for {{model}} · {{id}}",
    "requestsCount": "{{count}} requests",
    "seriesCount": "{{label}}: {{count}} requests",
    "leftAxis": "Left axis: {{unit}}",
    "rightAxis": "Right axis: {{unit}}",
    "chartAria": "{{title}} {{kind}}, ordered from earliest to latest date",
    "chartType": "Chart type",
    "chartBar": "Bars",
    "chartArea": "Area",
    "amountAxis": "Amount ({{currency}})",
    "datePages": "{{days}} days in this batch · Page {{page}} / {{pages}}",
    "overview": "Usage overview",
    "summary": "Usage summary",
    "details": "Billing details",
    "anomalies": "Billing anomalies",
    "minute": "Minute",
    "hour": "Hour",
    "day": "Day",
    "month": "Month",
    "user": "User",
    "channel": "Channel",
    "model": "Model",
    "operation": "Action",
    "billed": "Billed",
    "unsettled": "Unsettled",
    "billingFailed": "Billing failed",
    "unpriced": "Unpriced",
    "usageMissing": "Succeeded, no usage",
    "usageNotExpected": "Request not successful",
    "normalized": "Normalized",
    "partial": "Partially normalized",
    "invalid": "Normalization failed",
    "missing": "No usage",
    "dimensionMismatch": "Dimension mismatch",
    "settlementFailed": "Settlement failed",
    "userId": "User ID",
    "userSearch": "Email, username or user ID",
    "keySearch": "Key name, prefix or ID",
    "providerSearch": "Provider name or ID",
    "channelId": "Channel ID",
    "channelSearch": "Channel name or ID",
    "modelId": "Model ID",
    "modelSearch": "Model name, public ID or internal ID",
    "operationSearch": "Action name",
    "financialHint": "Successful settlements only. Sales and costs are shown in CNY using the exchange rate frozen at settlement. Original-currency costs remain in request details and exports.",
    "financialMetrics": "Financial metrics (CNY)",
    "sales": "Sales",
    "cost": "Cost",
    "grossHint": "CNY sales minus converted CNY costs. Requests with missing costs or exchange rates are excluded from gross profit.",
    "gross": "Gross profit",
    "marginHint": "CNY gross profit divided by CNY sales. Not shown when sales are zero or costs are incomplete.",
    "margin": "Gross margin",
    "coverageHint": "Successful settlements with CNY costs. Missing costs or exchange rates are not treated as zero; gross margin is hidden when cost coverage is incomplete.",
    "costCoverage": "Cost coverage",
    "selectedFilter": "Selected filter",
    "unconfirmedFilter": "Select a matching option or clear unconfirmed search text.",
    "invalidWindow": "Start must be before end. The interval includes start and excludes end.",
    "billing": "Billing",
    "normalization": "Normalization",
    "supplierModel": "Provider / model",
    "upstreamProvider": "Upstream provider",
    "unknownModel": "Unknown model",
    "loadingName": "Loading name…",
    "requests": "Requests",
    "succeeded": "Actual successes",
    "failed": "Failed",
    "tokens": "Token usage",
    "usageCoverage": "Metering coverage",
    "ratingStatus": "Billing status",
    "amounts": "Amounts (CNY)",
    "received": "Received",
    "request": "Request",
    "callOperation": "Call action",
    "providerModel": "Provider / upstream model",
    "status": "Status",
    "duration": "Duration",
    "salesCny": "Sales",
    "costCny": "Cost",
    "notConverted": "— · Not converted",
    "viewDetails": "View details",
    "title": "Usage statistics",
    "records": "Usage records",
    "callRecords": "Call records",
    "refreshing": "Refreshing…",
    "startLocal": "Start time (local time)",
    "endLocal": "End time (local time)",
    "quickRange": "Quick range",
    "today": "Today",
    "lastDay": "24 hours",
    "apply": "Apply filters",
    "summaryGranularity": "Time granularity (summary)",
    "granularity": "Time granularity",
    "noBuckets": "No time buckets",
    "summaryDimension": "Summary dimension",
    "ratingSearch": "Billing status",
    "normalizationStatus": "Normalization status",
    "normalizationSearch": "Normalization status",
    "loadingFresh": "Loading current usage and charges…",
    "loadingDaily": "Aggregating daily usage and charges…",
    "partialDates": "There are more date groups. Daily charts and tables show the current batch only. Page through or narrow the interval; partial data is not a full-interval total.",
    "previousDates": "Previous date batch",
    "nextDates": "Next date batch",
    "loadingSummary": "Aggregating usage…",
    "loadFailed": "Could not load data. Refresh to retry.",
    "emptySummary": "No requests to aggregate for these filters.",
    "loadingDetails": "Loading billing details…",
    "emptyDetails": "No billing details for these filters.",
    "cursorPage": "· Cursor pagination",
    "next": "Next →",
    "noMore": "No more data",
    "requestVolume": "Request volume",
    "successRate": "Actual success rate",
    "viewFailedCalls": "View failed calls",
    "successRateHint": "Based on final request or task outcomes. Tasks with background persistence must finish delivery. All requests include failures, rejections, cancellations and unfinished calls.",
    "usageCoverageRate": "Metering coverage",
    "usageCoverageHint": "Requests with usage evidence divided by all requests. Missing usage is not the same as a billing anomaly. Inspect request details for failures or missing usage.",
    "billedRate": "Billed rate",
    "billedRateHint": "Billed requests divided by all requests. A successful settlement counts as billed, including refunded records. Inspect billing anomalies for settlement issues.",
    "unfinished": "Ongoing requests",
    "unfinishedHint": "Calls awaiting execution or delivery, including accepted, queued, running and pending result persistence.",
    "viewAnomalies": "View anomaly reasons →",
    "noAnomalies": "No billing anomalies in this interval",
    "inputTokensHint": "Measured input tokens only; missing values are not zero. Images, audio and video are not converted to tokens.",
    "inputTokens": "Input tokens",
    "outputTokensHint": "Measured output tokens only; missing values are not zero. Images, audio and video are not converted to tokens.",
    "outputTokens": "Output tokens",
    "tokenRequestsHint": "Requests with at least one measured token metric, not all requests or usage across every modality.",
    "tokenRequests": "Requests with token metrics",
    "tokenRequestsShort": "Metered requests",
    "loadingTrend": "Loading request trend…",
    "category": "Category",
    "quantity": "Quantity",
    "dimensionId": "Dimension ID",
    "anomalyHint": "Five mutually exclusive categories, in precedence order: settlement failure, normalization failure, unpriced, missing usage and dimension mismatch. Missing usage only counts successful requests, not failures without usage.",
    "anomalyCategory": "Anomaly category",
    "breakdown": "Break down by:",
    "breakdownDimension": "Anomaly breakdown dimension",
    "noBreakdown": "No breakdown",
    "emptyBreakdown": "No anomalies for this breakdown.",
    "loadingAnomalies": "Loading billing anomalies…",
    "emptyAnomalies": "No billing anomalies for these filters.",
    "upstreamModel": "Upstream model",
    "reason": "Reason",
    "missingRate": " · Missing exchange rate: {{count}}",
    "missingCosts": " · Missing cost: {{count}}",
    "nameUnavailable": "{{group}} name unavailable",
    "days": "{{count}} days",
    "ratingCounts": "Billed {{billed}} · Unsettled {{unsettled}}",
    "coverageCounts": "Cost coverage {{reported}} / {{total}}",
    "moreFilters": "More filters",
    "pageCount": "Rows on this page: {{count}}",
    "missingCoverage": "Missing cost {{cost}} · Missing exchange rate {{rate}}",
    "successCount": "Actual successes {{count}}",
    "failedCount": "Failed {{count}}",
    "outputCount": "Output {{count}}",
    "inputCount": "Input {{count}}",
    "missingCount": "Missing {{count}}",
    "costAmount": "Cost {{amount}}",
    "historicalAmount": "Historical currency {{currency}} {{amount}}",
    "viewLabel": "Statistics view",
    "dailySuccessTrend": "Daily success rate",
    "advancedFilters": "Advanced filters",
    "modelComparison": "Compare models by type",
    "modelType": "Model type",
    "requestSource": "Request source",
    "executionFilters": "Execution",
    "billingFilters": "Billing status",
    "modelKindCount": "{{kind}} · {{count}}",
    "modelKinds": {
      "language": "Text",
      "image": "Image",
      "video": "Video",
      "audio": "Audio",
      "other": "Other / Unclassified"
    },
    "channelComparison": "Channel success rates",
    "unattributed": "Unattributed",
    "anomalyCount": "Billing anomalies · {{count}}",
    "failureReasons": "Failure reasons",
    "failureReasonsHint": "Top 10 recorded error codes, with the remainder grouped. Missing codes are explicit. Billing and metering status filters do not apply to this call-level view.",
    "otherFailureReasons": "Other error reasons",
    "failureRangeLimit": "Failure reasons support up to 366 days. Select a shorter range.",
    "filters": "Filters",
    "timeRange": "Time range",
    "relativeRanges": "Recent periods",
    "back": "Back",
    "timePresets": {
      "past15Minutes": "Past 15 minutes",
      "past30Minutes": "Past 30 minutes",
      "past1Hour": "Past 1 hour",
      "past3Hours": "Past 3 hours",
      "past24Hours": "Past 24 hours",
      "past48Hours": "Past 48 hours",
      "past1Week": "Past 1 week",
      "past1Month": "Past 30 days",
      "past1Year": "Past 365 days",
      "today": "Today",
      "yesterday": "Yesterday",
      "thisWeek": "This week",
      "previousWeek": "Previous week",
      "thisMonth": "This month",
      "previousMonth": "Previous month",
      "thisYear": "This year",
      "previousYear": "Previous year"
    },
    "customRange": "Custom time range",
    "appliedFilter": "{{name}}: {{count}}",
    "pendingFilters": "Unapplied changes",
    "appliedFilters": "Applied filters",
    "removeFilter": "Remove filter: {{name}}"
  },
  "adminCalls": {
    "result": "Call result",
    "loadFailed": "Could not load calls. Refresh to retry.",
    "task": "task",
    "request": "request",
    "endUser": "end-user",
    "copyId": "Copy {{kind}} ID {{id}}",
    "copyFullId": "Copy full {{kind}} ID",
    "idCopied": "{{kind}} ID copied",
    "copyFailed": "Copy failed",
    "copyManually": "Copy manually: {{id}}",
    "loadingTask": "Loading related task…",
    "relatedTask": "Related task",
    "taskHint": "The task result below is separate from API acceptance.",
    "emptyResult": "The task succeeded with an empty result.",
    "noResult": "The task ended without a result.",
    "pendingResult": "The task is not finished; no result is available yet.",
    "openVideo": "Open video ↗",
    "openImage": "Open image ↗",
    "openAsset": "Open output asset ↗",
    "fullTask": "View full execution details →",
    "async": "Async task",
    "direct": "Direct call",
    "selectedFilter": "Selected filter value",
    "stored": "Stored",
    "forwarded": "Forwarded",
    "pendingStorage": "Awaiting recovery",
    "storageFailed": "Storage failed",
    "noMedia": "No media",
    "refreshRequired": "Refresh required",
    "storageCount": "{{status}} · {{count}}",
    "unconfirmedFilter": "Select a matching option or clear unconfirmed search text.",
    "invalidWindow": "Start time must precede end time.",
    "recordId": "Request / task ID",
    "user": "User",
    "model": "Model",
    "kind": "Type",
    "status": "Status",
    "disposition": "Response handling",
    "duration": "Duration",
    "received": "Received",
    "storageDetails": "Storage details →",
    "idPlaceholder": "Full request or task ID",
    "callKind": "Call type",
    "kindPlaceholder": "All calls",
    "startLocal": "Start time (local time)",
    "endLocal": "End time (local time)",
    "endTime": "End time",
    "userPlaceholder": "Email, username or user ID",
    "modelPlaceholder": "Model name, public ID or internal ID",
    "protocol": "Protocol",
    "protocolPlaceholder": "All protocols",
    "statusPlaceholder": "All statuses",
    "apply": "Apply filters",
    "loading": "Loading call records…",
    "empty": "No calls match these filters",
    "pageCount": "Rows on this page: {{count}}",
    "cursorPage": " · Paginated results",
    "previous": "← Previous",
    "next": "Next →",
    "noMore": "No more data",
    "detailDescription": "Execution evidence: routing attempts, usage and settlement. Request and response bodies are not shown here.",
    "calls": "Call records",
    "detailTitle": "Request {{id}}",
    "detail": "Request details",
    "loadingDetail": "Loading request details…",
    "internalId": "Internal UUID",
    "methodPath": "Method and path",
    "caller": "Request source",
    "callerReported": "Caller-reported",
    "endUserId": "End-user ID",
    "endUserIp": "End-user IP",
    "clientIp": "Caller IP",
    "stream": "Streaming",
    "yes": "Yes",
    "no": "No",
    "acceptedAt": "API acceptance completed",
    "taskDuration": "Total task duration",
    "noTask": "This call did not create a task. Check API acceptance status and error information.",
    "attempts": "Routing attempts ({{count}})",
    "noAttempts": "No routing attempts were recorded. The request may have been rejected during authentication or validation.",
    "upstream": "Upstream",
    "started": "Started",
    "usage": "Usage records ({{count}})",
    "noUsage": "No usage evidence for this request.",
    "recordedAt": "Recorded at {{time}}",
    "rawFields": "Upstream fields: {{count}}",
    "noRawFields": "No raw fields",
    "metric": "Metric",
    "quantity": "Quantity",
    "charges": "Settlements ({{count}})",
    "noCharges": "No charges are linked to this request.",
    "sales": "Sales",
    "cost": "Cost",
    "settledAt": "Settled",
    "media": "Media assets",
    "output": "Output",
    "mediaCount": "{{role}} · {{count}}",
    "callsView": "Call record view",
    "errorsView": "Error view",
    "allCalls": "All calls",
    "billingDetails": "Billing details",
    "errors": "Errors and anomalies",
    "callErrors": "Call errors",
    "billingAnomalies": "Billing anomalies"
  },
  "adminUserActivity": {
    "title": "Financial and audit records",
    "kind": "Record type",
    "loading": "Loading records…",
    "empty": "No records",
    "time": "Time",
    "action": "Action",
    "amount": "Amount",
    "balanceAfter": "Balance after",
    "status": "Status",
    "reference": "References and audit",
    "recordId": "Record ID: ",
    "referenceId": "Reference ID: ",
    "actor": "Actor: ",
    "system": "System",
    "holdHint": "Reservations temporarily reduce the available balance. See the ledger for settled charges.",
    "ledger": "Ledger",
    "recharges": "Credits",
    "holds": "Reservations",
    "audit": "Audit",
    "held": "Reserved",
    "captured": "Captured",
    "released": "Released",
    "expired": "Expired and released",
    "credited": "Credited",
    "pending": "Pending",
    "failed": "Failed",
    "refunded": "Refunded",
    "recharge": "Credit",
    "charge": "Charge",
    "refund": "Refund",
    "adjustment": "Adjustment",
    "opening": "Opening balance",
    "openWallet": "Open wallet",
    "updateUser": "Update user",
    "updateKey": "Update API key",
    "setDiscount": "Set user discount"
  },
  "adminUsers": {
    "delete": "Delete user",
    "deleteTitle": "Confirm user deletion",
    "confirmDelete": "Confirm deletion",
    "deleted": "User deleted",
    "deleteHelp": "Only unused accounts can be deleted. Accounts with funds, consumption, calls, tasks or other business history must be suspended instead. Your account and the last administrator cannot be deleted.",
    "userStatus": "User status",
    "walletLabel": "Wallet",
    "consumptionTotal": "Lifetime consumption (settled)",
    "cnyBalance": "CNY balance",
    "cnyReserved": "CNY request reservations",
    "cnyWalletStatus": "CNY wallet status",
    "consumptionHelp": "Includes all successfully settled charges, excluding refunded charges. Currencies are shown separately.",
    "requests30d": "Calls in 30 days",
    "walletStatusFilter": "Filter wallet status",
    "allWalletStatuses": "All wallet statuses",
    "requestCount": "Requests: {{value}}",
    "viewUser": "View {{email}}",
    "pageSummary": "Rows: {{count}} · Page {{page}}",
    "creditReceipt": "Balance: {{balance}}; credit ID: {{rechargeId}}; ledger ID: {{ledgerId}}",
    "existingCredit": "No duplicate credit; credit ID: {{rechargeId}}",
    "discountValue": "{{percent}}% discount",
    "roleDescription": "Change role from {{from}} to {{to}}.",
    "banDescription": "Banning {{email}} prevents further API calls. Existing bills and history are preserved.",
    "unbanDescription": "Unbanning {{email}} restores normal API access.",
    "revokeDescription": "Revoking {{name}} ({{hint}}) invalidates it immediately and cannot be undone. Historical bills are unaffected.",
    "retireMultiplierTitle": "Retire price multiplier ×{{value}}",
    "discountPreview": "Discount: {{discount}}%. The user pays {{payable}}% of the sale price.",
    "multiplierPreview": "The customer pays {{percent}}% of the standard sale price.",
    "roleAdmin": "Administrator",
    "roleDealer": "Dealer",
    "roleUser": "User",
    "banned": "Banned",
    "active": "Active",
    "unconfigured": "Profile needs repair",
    "keyActive": "Active",
    "revoked": "Revoked",
    "expired": "Expired",
    "reason": "Reason (required; recorded in admin audit)",
    "reasonExample": "For example: ticket #1234, requested account reinstatement",
    "unnamed": "Unnamed",
    "role": "Role",
    "status": "Status",
    "keyCount": "Active API keys",
    "walletSummary": "Wallets (total / reserved)",
    "reserved": "Reserved",
    "walletNotReady": "Wallet unavailable",
    "usage30d": "Requests in last 30 days",
    "lastKeyUse": "Last API key use",
    "details": "Details ›",
    "title": "Users",
    "search": "Search users",
    "searchPlaceholder": "Email, name or exact user ID",
    "roleFilter": "Filter by role",
    "allRoles": "All roles",
    "statusFilter": "Filter by status",
    "allStatuses": "All statuses",
    "loading": "Loading users…",
    "empty": "No matching users",
    "previous": "← Previous",
    "next": "Next →",
    "noMore": "No more users",
    "saved": "Settings saved",
    "credited": "Manual credit posted",
    "alreadyCredited": "Credit already processed",
    "discountSaved": "User discount saved",
    "multiplierSaved": "Price multiplier saved",
    "multiplierRetired": "Price multiplier retired",
    "loadingDetail": "Loading user details…",
    "name": "Name",
    "maskedKey": "API key (masked)",
    "createdAt": "Created",
    "expiresAt": "Expires",
    "revoke": "Revoke",
    "back": "← Back to users",
    "viewUsage": "View user usage ↗",
    "adjustRole": "Change role",
    "repair": "Repair user profile",
    "unban": "Unban user",
    "ban": "Ban user",
    "registered": "Registered",
    "emailVerification": "Email verification",
    "verified": "Verified",
    "unverified": "Not verified",
    "maskedKeys": "API keys (prefix and last four characters only)",
    "noKeys": "This user has no API keys",
    "wallets": "Wallets",
    "recharge": "Manual credit",
    "currency": "Currency",
    "balance": "Total balance",
    "available": "Available balance",
    "walletStatus": "Wallet status",
    "frozen": "Frozen",
    "closed": "Closed",
    "noWallet": "This user has no wallets",
    "walletUnavailable": "This user's wallet is not ready. Manual credit is unavailable.",
    "discounts": "User discounts",
    "createDiscount": "Create discount",
    "model": "Model",
    "operation": "Operation",
    "discount": "Discount",
    "effective": "Validity",
    "note": "Note",
    "noDiscount": "This user has no model discounts",
    "multiplier": "Price multiplier",
    "setMultiplier": "Set multiplier",
    "subject": "Subject",
    "allUserKeys": "This user (all API keys)",
    "deletedKey": "Deleted API key",
    "scope": "Scope",
    "allModels": "Global (all models)",
    "multiplierShort": "Multiplier",
    "discounted": "Discounted",
    "markup": "Markup",
    "standard": "Standard price",
    "retire": "Retire",
    "noMultiplier": "This user has no price multiplier rules",
    "multiplierHint": "Customer price = standard sale price × multiplier. API key rules take precedence over user rules, and model rules over global rules. Only one rule applies at a time; rules for the same subject and scope cannot overlap.",
    "usageSummary": "Usage summary: last 30 days",
    "usageHint": "Grouped by request receipt time. Sales include successfully settled charges; historical requests may belong to revoked or deleted API keys.",
    "requests": "Requests",
    "sales": "Sales",
    "confirmChange": "Confirm change",
    "targetRole": "New role",
    "changeRoleTitle": "Change user role",
    "confirmRepair": "Confirm repair",
    "repairHint": "Recreate the default user profile and set it to active, preserving the registered identity and history. Verify the registration record and provide a reason.",
    "confirmBan": "Confirm ban",
    "confirmUnban": "Confirm unban",
    "revokeKey": "Revoke key",
    "revokeKeyTitle": "Revoke API key",
    "confirmRetire": "Confirm retirement",
    "retireHint": "Retiring this rule takes effect immediately and returns pricing to the standard sale price. Historical bills retain their original snapshots.",
    "chooseModel": "Search and select a model",
    "searchDiscountModel": "Search discount models",
    "modelSearchPlaceholder": "Model name or ID (up to 50 matches)",
    "discountModel": "Discount model",
    "selectModel": "Model",
    "noMatchingModel": "No matching models",
    "capability": "Operation",
    "discountOperation": "Discount operation",
    "loadingOperations": "Loading operations…",
    "noOperations": "No available operations",
    "discountRange": "Discount percentage (0–100%)",
    "discountPercent": "Discount percentage",
    "discountExample": "For example, 20 gives a 20% discount",
    "discountHint": "A 20% discount means paying 80% of the sale price; 0 restores the base sale price. The remaining validity of the original agreement is preserved after a limited promotion ends.",
    "effectiveStart": "Effective from (local time)",
    "discountStart": "Discount start",
    "hasEnd": "Set an end time (unchecked = no expiry)",
    "discountEnd": "Discount end",
    "auditReason": "Reason (required; recorded in audit)",
    "optionalNote": "Note (optional)",
    "discountNoteExample": "For example: enterprise agreement discount",
    "creating": "Creating…",
    "userSubject": "This user (applies to all API keys)",
    "keyInactive": ", inactive",
    "setMultiplierTitle": "Set price multiplier",
    "effectiveSubject": "Subject",
    "multiplierSubject": "Multiplier subject",
    "subjectHint": "API key multipliers take precedence over user multipliers; when both apply, only the key-level multiplier is used.",
    "multiplierScope": "Multiplier scope",
    "globalScope": "Global (all models for this subject)",
    "modelScope": "Specific model and operation",
    "searchMultiplierModel": "Search multiplier models",
    "multiplierModel": "Multiplier model",
    "multiplierOperation": "Multiplier operation",
    "multiplierRange": "Price multiplier (0.0001–5; up to 4 decimal places)",
    "multiplierExample": "For example, 0.9 means paying 90%",
    "multiplierPricingHint": "Customer price = standard sale price × multiplier. Below 1 is a discount (0.9 = 90%); above 1 is a markup (1.2 = 20% extra). Only one multiplier applies per subject at a time; multipliers do not stack.",
    "multiplierStart": "Multiplier start",
    "multiplierEnd": "Multiplier end",
    "multiplierNoteExample": "For example: enterprise pricing",
    "saving": "Saving…",
    "saveMultiplier": "Save multiplier",
    "rechargeAmount": "Credit amount (CNY; positive; up to 8 decimal places)",
    "amountExample": "For example: 100.00",
    "crediting": "Posting credit…",
    "confirmCredit": "Confirm credit"
  },
  "modelAnalytics": {
    "scope": "Loaded task samples only, not complete API usage. Charges are shown separately by currency.",
    "loadedTasks": "Loaded tasks",
    "charges": "Recorded charges",
    "title": "Model tasks for this account",
    "sample": "Loaded sample",
    "empty": "No analytics data"
  },
  "conversation": {
    "completed": "Done {{completed}}/{{total}}",
    "totalTokens": "Total {{value}} tokens",
    "title": "Multi-model conversation",
    "modelCount": "Models: {{count}}",
    "layout": "Conversation columns",
    "oneColumn": "One column",
    "twoColumns": "Two columns",
    "threeColumns": "Three columns",
    "totalDurationHint": "Sum of model request durations, not elapsed waiting time",
    "totalDuration": "Combined model time {{duration}}",
    "structuredInput": "Structured input",
    "copyId": "Copy ID: {{id}}",
    "broadcastPlaceholder": "Follow up with all models ({{count}})…",
    "sending": "Sending…",
    "broadcast": "Follow up with all",
    "modelResult": "{{model}} conversation results",
    "markBest": "Mark as best answer",
    "unmarkBest": "Remove best answer mark",
    "requesting": "Requesting this model…",
    "generatingReply": "Generating follow-up reply…",
    "replyFailed": "Follow-up failed",
    "reply": "Follow-up reply",
    "emptyResponse": "The model returned an empty text response.",
    "singlePlaceholder": "Follow up with {{model}}…",
    "sendSingle": "Send follow-up to {{model}}",
    "noEndpoint": "{{model}}: No language endpoint available",
    "streamEvents": "{{protocol}} SSE · Events: {{count}}",
    "streamStatus": "{{protocol}} SSE · {{status}}",
    "reasoningEvidence": "Reasoning data: ",
    "observed": "Returned",
    "notObserved": "Not returned",
    "notReported": "Not reported",
    "reasoningItems": "Items: "
  },
  "tokenUsage": {
    "title": "Token and context usage",
    "system": "System prompt",
    "user": "Input tokens (conversation)",
    "reasoning": "Reasoning",
    "tools": "Tool calls",
    "output": "Output tokens (model reply)",
    "firstTurn": "Turn 1 (initial request)",
    "followupTurn": "Turn {{count}} (follow-up {{followup}})",
    "systemDetail": "System prompt: {{count}} characters",
    "noSystem": "No separate system prompt",
    "noInput": "No text input",
    "reasoningDetail": "Reasoning recorded · {{count}} tokens{{items}}",
    "reasoningItems": " (Items: {{count}})",
    "noReasoning": "No reasoning recorded",
    "toolDetail": "Calls: {{count}} · {{names}}",
    "noTools": "No tool calls",
    "outputDetail": "Reply: {{count}} characters",
    "generating": "Generating…",
    "noOutput": "No reply text",
    "distribution": "Token category distribution",
    "totalDuration": "Total duration {{duration}}",
    "total": "Total tokens",
    "inputOutput": "Input: {{input}} · Output: {{output}}",
    "turns": "Turn details ({{count}})",
    "turnHint": "Actions and results per turn",
    "conversation": "Conversation",
    "thinkingItems": "Reasoning · Items: {{count}}",
    "thinking": "Reasoning",
    "estimateHint": "Some categories are estimated from text length. For analysis only, not billing.",
    "open": "View {{model}} token distribution and timing",
    "outputCount": "(Output: {{value}})",
    "toolCount": "Tool calls executed: {{count}}",
    "unrecorded": "Token usage not recorded",
    "unrecordedHint": "Token usage was not saved for some or all turns. Missing values are not shown as zero."
  },
  "requestHistory": {
    "expandRequests": "Show earlier requests ({{count}})",
    "collapseRequests": "Hide earlier requests ({{count}})",
    "earlierRequestCount": "{{count}} more",
    "earlierRequests": "Earlier consecutive text requests",
    "groupEnd": "End of this request group",
    "clientIp": "Caller IP: {{value}}",
    "endUserIp": "End-user IP: {{value}}",
    "pagination": "Request history pagination",
    "pageNumber": "Page {{page}}",
    "loadingPage": "Loading",
    "loadFailed": "Could not load more records. Please retry.",
    "details": "Details",
    "openRecord": "View request {{id}}",
    "list": "List",
    "compact": "Compact",
    "grid": "Grid",
    "expand": "Show more",
    "collapse": "Show less",
    "preparation": "Request preparation",
    "generation": "Model processing",
    "mediaInfo": "Media information",
    "mediaSize": "Size: {{size}}",
    "mediaDuration": "Duration: {{duration}}",
    "refunded": "Refunded",
    "noSettlement": "No settlement recorded",
    "costPrefix": "Cost: ",
    "caller": "Request source: {{value}}",
    "endUser": "End-user ID: {{value}}",
    "copyEndUserId": "Copy end-user ID",
    "previousMedia": "Previous media",
    "nextMedia": "Next media",
    "selectMedia": "View result {{count}}",
    "videoFailed": "Video generation failed",
    "imageFailed": "Image generation failed",
    "noMedia": "The request returned no usable media",
    "errorCode": "Error code: {{code}}",
    "conversation": "Conversation",
    "duration": "Timing",
    "noInput": "No request parameters",
    "noResponse": "Response not retained",
    "responseStatus": "Response status",
    "platformError": "Platform error",
    "platformResponseParams": "Platform response parameters",
    "providerResponseParams": "Original provider response parameters",
    "providerResponseMissing": "Original provider response parameters were not retained",
    "errorParam": "Parameter: {{param}}",
    "upstreamError": "Original provider error",
    "upstreamDecodedError": "Provider error (decoded)",
    "upstreamMessageMissing": "The provider did not supply a displayable error message.",
    "upstreamErrorMissing": "No provider error content is available",
    "upstreamRedacted": "Sensitive content was redacted",
    "upstreamTruncated": "Error evidence was truncated",
    "upstreamUnavailable": {
      "no_response": "No upstream response was received",
      "not_retained": "The original provider error was not retained",
      "unsupported_capture": "The original provider error could not be captured",
      "error_not_emitted": "The upstream service did not emit error content",
      "size_limit": "The original provider error exceeds the size limit"
    },
    "errorCategory": "Category: {{category}}",
    "retryableYes": "Retryable: Yes",
    "retryableNo": "Retryable: No",
    "loading": "Loading request details…",
    "notFound": "Request not found",
    "title": "Request history",
    "description": "Loaded model playground and API requests. Load more to see earlier history.",
    "modelCategory": "Model category",
    "allModelCategories": "All model categories",
    "allTypes": "All types",
    "taskType": "Async tasks",
    "apiType": "API calls",
    "noRecords": "0 records",
    "pageRange": "{{start}}–{{end}} of {{count}}{{more}} loaded",
    "emptyHint": "Try changing your search or resetting the filters.",
    "noPrompt": "No prompt",
    "restoreConversation": "Restore conversation and continue",
    "task": "Task",
    "sessionTurns": "Session · turns: {{count}}",
    "unknownModel": "Unknown model",
    "output": "Generated output",
    "copySessionId": "Copy Session ID",
    "copyRequestId": "Copy Request ID",
    "seed": "Seed",
    "size": "Size",
    "aspectRatio": "Aspect ratio",
    "steps": "Steps",
    "guidance": "Guidance",
    "notCharged": "Not charged"
  },
  "wallet": {
    "openingBalance": "Opening balance",
    "recharge": "Top up",
    "charge": "Charge",
    "refund": "Refund",
    "adjustment": "Adjustment",
    "entryType": "Type",
    "amount": "Amount",
    "balanceAfter": "Balance after",
    "reference": "Reference",
    "description": "Prepaid balance and transactions. Model calls place a hold first, then settle the charge.",
    "entries": "Transactions",
    "noEntries": "No transactions yet",
    "available": "Available balance",
    "reserved": "Reserved for requests",
    "understood": "Got it",
    "rechargeTitle": "Top up {{currency}} wallet",
    "rechargeGuide": "Self-service top-ups are not available. Enterprise contract customers can contact sales; entries appear on this page once the account is credited.",
    "model": "Model",
    "operation": "Operation",
    "viewRequest": "View request and billing",
    "noWallet": "No wallet yet"
  },
  "taskCost": {
    "awaitingReview": "Cost awaiting review",
    "noRecordedCost": "No recorded cost yet",
    "unconfirmed": " (unconfirmed task costs: {{count}})",
    "pending": "Pending settlement",
    "failed": "Settlement failed",
    "refunded": "Includes refunds; check your bill",
    "mixedCurrencies": "Multiple currencies; no combined total",
    "usageUnavailable": "Missing billable usage",
    "usageInvalid": "Invalid billable usage",
    "usageIncomplete": "Incomplete billable usage",
    "evidenceInvalid": "Invalid billing evidence",
    "evidenceIncomplete": "Incomplete billing evidence",
    "holdUnavailable": "Balance authorization unavailable",
    "priceUnavailable": "Missing sale price",
    "pricingUnavailable": "Invalid sale pricing"
  },
  "settings": {
    "description": "Account, usage, and developer settings.",
    "general": "General",
    "usageBilling": "Usage and billing",
    "wallet": "Wallet",
    "developer": "Developer",
    "keyCreateFailed": "Could not create the key",
    "keyRevokeFailed": "Could not revoke the key",
    "key": "Key",
    "scopes": "Scopes",
    "lastUsed": "Last used",
    "revoke": "Revoke",
    "keysDescription": "The full key is shown only once when created. Only an irreversible hash is retained afterward.",
    "newKey": "New key",
    "noKeys": "This account has no API keys",
    "moreKeys": "Load more keys",
    "revokeTitle": "Revoke API key?",
    "revokeDescription": "{{name}} will stop working immediately. This action cannot be undone.",
    "revokeKey": "Revoke key",
    "keyCreated": "API key created",
    "createKey": "Create API key",
    "copyKeyWarning": "Copy this key now. You will not be able to view it again after closing.",
    "copyKey": "Copy key",
    "defaultKeyName": "Default key",
    "expiration": "Expiration",
    "neverExpires": "Never expires",
    "days": "{{count}} days",
    "oneYear": "1 year",
    "creatingKey": "Creating…",
    "accountDescription": "The account currently signed in to this console.",
    "searchNavigation": "Search {{title}}",
    "signInDetail": "Sign in to view your tasks, requests, and usage."
  },
  "usageSample": {
    "title": "Recent usage sample",
    "description": "Shows the latest 20 tasks and 20 API requests, not a complete bill. Amounts are separated by currency; unknown costs are not treated as free.",
    "recentSample": "Latest {{count}} samples",
    "modelEndpoint": "Model endpoint",
    "taskCount": "Tasks",
    "successCount": "Succeeded",
    "recordedCost": "Recorded cost",
    "sampleRequests": "Sample requests",
    "succeededTasks": "Succeeded tasks",
    "failedSamples": "Failed or rejected samples",
    "modelsUsed": "Models used",
    "successRate": "Success rate",
    "requestsHint": "Recent API request samples",
    "costHint": "Loaded tasks only, not a complete bill",
    "submittedTasks": "{{count}} tasks submitted",
    "failuresHint": "Task and request samples are counted separately",
    "modelsHint": "Distinct task models",
    "rateHint": "Based on terminal task statuses",
    "trend": "Usage trend",
    "dailyRequests": "{{date}}: {{count}} requests",
    "distribution": "Usage distribution",
    "tasksByModel": "Tasks grouped by model",
    "noTasks": "No task usage yet.",
    "modelUsage": "Model API usage",
    "currentAccount": "Current account",
    "noUsage": "No usage data"
  },
  "taskDocs": {
    "authorization": "Use your Nexra API Key after Bearer.",
    "idempotencyTitle": "Idempotency key",
    "idempotency": "Use a new value for each new task. Keep it unchanged when retrying the same submission.",
    "requestFormat": "Request format",
    "publicModelId": "Platform model ID",
    "modelInput": "Model parameters",
    "callbackTitle": "Completion callback URL",
    "callback": "Optional public HTTPS URL. Nexra POSTs a completion notification when the task succeeds, fails or is cancelled, preserving URL query parameters. Without a callback, query the task for its result.",
    "metadataTitle": "Business metadata",
    "metadata": "Optional JSON object, such as an order number or project ID. View it in request details; it is not sent to the model upstream. Do not include keys or sensitive information.",
    "taskResult": "Task status and result. The output field appears only when a result is available.",
    "taskId": "Platform task ID",
    "requestId": "Request ID",
    "requestDetails": "Use GET /v1/requests/{requestId} to view costs, business metadata and stage durations.",
    "taskStatus": "Task status",
    "modelOutput": "Final model output",
    "assetsTitle": "Media assets",
    "assets": "Media assets recorded by the platform. Only ready assets have accessible URLs; original URLs in output are not replaced.",
    "assetId": "Asset ID",
    "assetKind": "Asset type",
    "assetStatus": "Save status",
    "assetUrl": "Access URL",
    "downloadUrl": "Download URL",
    "error": "Error",
    "errorCode": "Error code",
    "errorMessage": "Error message",
    "nativeCallbackTitle": "Callback URL",
    "nativeCallback": "Receive task status notifications. Nexra records the result, then forwards the notification in its native format.",
    "nativeCallbackChallenge": "MiniMax sends status notifications directly to this URL. Return its challenge unchanged within 3 seconds to complete callback verification.",
    "upstreamTaskId": "Upstream task ID",
    "returnedId": "The id returned when the task was created.",
    "returnedOrUpstreamId": "The id returned when the task was created, or the upstream task ID in a provider callback.",
    "modelName": "Model name",
    "accepted": "Task accepted. Use id to query status and results. Idempotent retries return the current state of the same task.",
    "queried": "Returns task status and results. HTTP 200 means the query succeeded; check status to determine whether the task has finished.",
    "cancelled": "Only queued tasks that have not started can be cancelled. If execution has started, HTTP 409 is returned and the task continues. Finished tasks retain their state and records.",
    "deleted": "Cancellation or deletion depends on the upstream task's state. Unsupported operations return the upstream error unchanged. Deleting a record does not mean generation stops.",
    "selectModel": "Select the platform model: {{modelId}}. You may also use a registered public alias for this model."
  },
  "apiDocs": {
    "errorRequestHeadersTitle": "Request headers",
    "errorResponseHeadersTitle": "Response headers",
    "errorRequestHeadersExample": "Task creation request headers example",
    "errorResponseHeadersExample": "Reading optional response headers",
    "errorPageTitle": "Errors and Troubleshooting",
    "errorHeadersTitle": "Request and response headers",
    "errorHeaderName": "Header name",
    "errorHeaderRule": "Handling rules and applicable scenarios",
    "errorHeaderRules": {
      "authorization": "API key calls generally use Authorization: Bearer <NEXRA_API_KEY>. Supported platform endpoints can also use a session. Native authentication follows the selected protocol; Bearer is not universal.",
      "content_type": "Use application/json for JSON requests. File edits and other multipart calls retain their protocol format, with the client generating the boundary. Not every Native request is JSON.",
      "accept_language": "Public messages support zh-CN and en. Missing or unsupported values, such as cn, fall back to en; provider bodies are not translated.",
      "x_nexra_client_request_id": "Optional. Generate a UUID to identify the original request; the platform generates an ID when omitted. This is a correlation ID, not an idempotency key. Use the sent ID to locate the platform record.",
      "idempotency_key": "Required by idempotent endpoints such as Task creation. Reuse the same idempotency key when repeating identical request content. Not all Native endpoints require it; it does not decide whether to generate again after failure.",
      "x_request_id": "Responses may retain an upstream value. A Native value may be a provider ID; do not assume it is nexraRequestId. The authoritative platform ID comes from the public nexraRequestId or the original client UUID.",
      "content_language": "Localized platform errors and Task / Request reads indicate the public message language. Not every Native provider response has this header.",
      "x_nexra_error_code": "Read the unified code when this header is present on a classified Native error. Not every failure has it, and errors after stream headers have been sent may not update it."
    },
    "errorShortMeaning": "Short meaning",
    "errorActionMessage": "Cause and suggested action",
    "errorNexraInterpretation": "How to interpret in Nexra",
    "errorJudgement": "How to evaluate and act",
    "errorHttpTitle": "HTTP status codes",
    "errorTaskTitle": "Task status",
    "errorAllCodesTitle": "All error codes",
    "errorPageToc": "On this page",
    "errorCodeMeanings": {
      "content_policy_violation": "Content policy rejection",
      "rate_limited": "Request rate or concurrency limit",
      "invalid_request": "Invalid request parameters",
      "asset_too_large": "Input asset exceeds the file size limit",
      "upstream_timeout": "Timed out waiting for the provider",
      "upstream_busy": "Provider service busy",
      "upstream_unavailable": "Provider service unavailable",
      "execution_outcome_unknown": "Execution outcome unconfirmed",
      "stream_interrupted": "Response stream interrupted",
      "task_execution_timeout": "Task total time limit exceeded"
    },
    "errorHttpMeanings": {
      "200": {
        "meaning": "Request succeeded",
        "guidance": "A successful query does not mean the task succeeded. Read Task status, nexraError and stream termination."
      },
      "202": {
        "meaning": "Request accepted",
        "guidance": "Acceptance does not mean generation succeeded. Keep the Task ID and query its status and result."
      },
      "400": {
        "meaning": "Invalid or unprocessable request",
        "guidance": "Follow the current nexraError.code and parameter guidance. A Native provider 400 may also be a moderation refusal; do not classify by status alone."
      },
      "401": {
        "meaning": "Valid authentication is missing",
        "guidance": "Check Nexra credentials for platform requests. A forwarded Native provider 401 belongs to its authentication boundary; do not assume the customer’s Nexra key is invalid."
      },
      "402": {
        "meaning": "Reserved by the HTTP standard",
        "guidance": "Nexra may use this for balance or budget limits. Follow public nexraError.code / nexraError.message and check the platform balance and applicable budget."
      },
      "403": {
        "meaning": "The service refuses the request",
        "guidance": "Check permissions, resource ownership and the public error. Evaluate provider refusals separately from platform access."
      },
      "404": {
        "meaning": "Target resource was not found",
        "guidance": "Verify the route, resource or model ID and its visibility to the current identity."
      },
      "408": {
        "meaning": "The server timed out waiting for a complete request",
        "guidance": "Check request delivery and network conditions. This is not necessarily model inference timeout; verify whether the original request was accepted before generating again."
      },
      "409": {
        "meaning": "Request conflicts with current resource state",
        "guidance": "Review state, the idempotency key and its associated request content to avoid duplicate generation."
      },
      "413": {
        "meaning": "Request content exceeds the allowed size",
        "guidance": "Review input file or body limits and reduce the request. This differs from the public diagnostic 16 KiB budget."
      },
      "422": {
        "meaning": "Content can be parsed but its instructions cannot be processed",
        "guidance": "Follow parameter or semantic validation guidance; do not interpret this as a JSON parsing failure."
      },
      "429": {
        "meaning": "Too many requests",
        "guidance": "Reduce frequency or concurrency and review applicable quotas. A Retry-After header is not guaranteed."
      },
      "500": {
        "meaning": "The service encountered an internal error",
        "guidance": "Trace the record with the platform ID and check the original outcome. Retrying is not guaranteed to be safe."
      },
      "502": {
        "meaning": "Gateway received an invalid upstream response",
        "guidance": "Distinguish platform and provider status. Review the original request and diagnostics before acting; do not automatically generate again."
      },
      "503": {
        "meaning": "Service temporarily unavailable",
        "guidance": "Check availability and original request progress. The provider may have executed the request; do not automatically retry generation."
      },
      "504": {
        "meaning": "Gateway timed out waiting for a timely upstream response",
        "guidance": "The provider may continue executing. Query the original Task or request before deciding whether to resubmit."
      }
    },
    "errorTaskMeanings": {
      "queued": {
        "meaning": "Task queued",
        "guidance": "Wait for scheduling and query the same Task ID rather than creating another task."
      },
      "running": {
        "meaning": "Task executing",
        "guidance": "Continue checking progress. Without a terminal state, do not claim failure or completed generation."
      },
      "succeeded": {
        "meaning": "Model execution succeeded",
        "guidance": "Still check deliveryStatus and assets: preparing means background storage is in progress, ready means delivery is ready, and failed means delivery failed. Do not generate again just because of delivery state."
      },
      "failed": {
        "meaning": "Task execution failed",
        "guidance": "Read nexraError.code, the platform explanation and provider diagnostics. Check the original request for unknown outcomes to avoid duplicate submissions."
      },
      "cancelling": {
        "meaning": "Cancellation requested",
        "guidance": "Cancellation is not yet confirmed. Continue querying; do not treat this as cancelled or assume the provider did not execute."
      },
      "cancelled": {
        "meaning": "Task cancelled",
        "guidance": "This is a platform terminal state, not proof the provider never executed. Check the original request and any produced results before a new submission."
      }
    },
    "errorReference": "Error Reference",
    "errorShape": "Error JSON and examples",
    "errorHttpExample": "Synchronous HTTP error",
    "errorTaskExample": "Asynchronous Task failure",
    "errorNativeExample": "Native provider response",
    "errorFieldsTitle": "Field reference",
    "errorField": "Field",
    "errorDescription": "Meaning and suggested action",
    "errorCode": "Error code",
    "errorCommon": "Common error codes",
    "errorAllCodes": "All error codes ({{count}})",
    "errorFields": {
      "nexraHttpStatus": "Actual HTTP status of the originating Nexra request; Task metadata retains creation status rather than a later GET 200.",
      "upstreamHttpStatus": "Captured provider HTTP status, independent of the Nexra status.",
      "nexraRequestId": "Nexra request ID, appearing once at the root on success and failure.",
      "upstreamRequestId": "Request ID captured from provider headers; do not substitute it for the Nexra ID.",
      "nexraError": "Platform error classification and explanation, omitted on success.",
      "nexraError_code": "Platform code for exact application branching.",
      "nexraError_message": "Platform cause and action, localized to the request language.",
      "nexraError_param": "Optional validated parameter name or path.",
      "upstreamError": "Captured opaque provider error content, with no extra body wrapper. It can be a scalar or null and may be redacted or absent. Capture including metadata is limited to 16 KiB.",
      "upstreamErrorMessage": "Original provider error text extracted from captured diagnostics, preserving its language and line breaks. Omitted when no supported text is available.",
      "upstreamRedacted": "True when diagnostic content was redacted.",
      "upstreamTruncated": "True when capture was limited; content may be omitted.",
      "upstreamUnavailableReason": "Reason diagnostic content is unavailable; does not prove no provider call occurred.",
      "upstreamFormat": "sse or decoded identifies framed or decoded evidence, not raw transport bytes.",
      "upstreamEvent": "Captured provider SSE event name when present."
    },
    "taskIntro": "Submit an asynchronous task, then query its status and result or receive a completion notification via callback_url.",
    "protocolIntro": "Call this model using {{protocol}}.",
    "unavailable": "No API is currently available for this model.",
    "client": "The Nexra TypeScript client supports Bun, Node.js and modern JavaScript runtimes. You can also call the HTTP API directly.",
    "submit": "Send the catalog model ID and input object. Reusing an idempotency key returns the existing task without starting another generation.",
    "query": "Use the task ID returned on submission to query status and results.",
    "files": "Provide public HTTPS media URLs or resource URLs obtained after uploading.",
    "snapshots": "These snapshots pin model weights to a specific date and share this model's endpoints and parameter definitions. Use the snapshot ID in your request body.",
    "snapshotCount": "Snapshots: {{count}}",
    "providerParameters": "Parameters for this endpoint may differ from the official API. Refer to the selected channel's documentation."
  },
  "parameters": {
    "operations": "API operations",
    "operationDocs": "{{operation}} documentation",
    "copied": "Copied {{label}}",
    "copyFailed": "Copy failed",
    "copyManually": "Please select and copy manually",
    "displayMode": "Parameter display",
    "visual": "Visual",
    "json": "JSON source",
    "definition": "parameter definition",
    "copyDefinition": "Copy definition",
    "selectExample": "Select request example",
    "example": "Example {{number}}",
    "requestExample": "Request example {{number}}",
    "copyExampleNumber": "Copy request example {{number}}",
    "copyExample": "Copy request example",
    "operation": {
      "create": "Create task",
      "query": "Query task",
      "cancel": "Cancel task",
      "delete": "Cancel or delete",
      "generate": "Generate image",
      "audioGenerate": "Generate audio",
      "edit": "Edit image",
      "videoEdit": "Edit video",
      "videoExtend": "Extend video",
      "stream": "Stream",
      "request": "Request"
    },
    "requestOperation": {
      "list": "List resources",
      "presets": "Official resources",
      "text-to-video": "Text to video",
      "image-to-video": "Image to video",
      "omni-video": "Omni video",
      "text2video": "Text to video",
      "image2video": "Image to video",
      "transition": "First and last frames",
      "reference2video": "Reference to video",
      "fusion": "Reference to video",
      "convert": "Synthesize speech",
      "stream": "Stream response",
      "convert-with-timestamps": "Synthesize speech with timestamps",
      "stream-with-timestamps": "Stream response with timestamps",
      "remix": "Continue video",
      "delete-video": "Delete video",
      "delete-interaction": "Delete interaction",
      "realtime": "Real-time recognition",
      "sentence": "Sentence recognition"
    },
    "response": {
      "create": "Creation response",
      "query": "Query response",
      "cancel": "Cancellation response",
      "delete": "Deletion response",
      "result": "Response"
    },
    "nativeOutput": "Native model output",
    "nativeInput": "Native model parameters",
    "alwaysReturned": "Always returned",
    "required": "Required",
    "generatedResult": "Generated output",
    "outputScope": "Fields within the output object.",
    "inputScope": "Place these fields in the request body's input object.",
    "fixedValue": "Fixed value",
    "values": "Values",
    "defaultSuffix": "· Default",
    "urlItem": "Each item is a URL",
    "contentTypes": "Content types in the content array",
    "missingStructure": "Structure is not yet documented. Refer to the API documentation.",
    "singleMessage": "Input message (one only) <code>input.messages[0]</code> · <code>role: \"user\"</code>",
    "rejectedField": "Field <code>{{name}}</code> is not accepted.",
    "typedContent": "Combine content in order. Each item specifies its type using <code>type</code>.",
    "content": "Combine content in order. Each item uses one of the fields below.",
    "separator": "; ",
    "roles": "Media roles: {{roles}}",
    "listSeparator": ", ",
    "contentType": "{{type}} content type",
    "formats": "Accepted formats · {{count}}",
    "itemFormats": "Formats accepted per item · {{count}}",
    "format": "Format {{number}}",
    "reference": "Referenced definition: <code>{{reference}}</code> (see JSON source)",
    "fields": "Fields · {{count}}",
    "itemFields": "Fields per item · {{count}}",
    "anyGroup": "Provide at least one group: {{groups}}.",
    "oneGroup": "Match exactly one group: {{groups}}.",
    "combinationConstraints": "See JSON source for the complete combination constraints.",
    "orSeparator": ", or ",
    "autoRange": "{{min}}–{{max}}{{unit}}; {{auto}} for automatic",
    "fixed": "Fixed at {{value}}{{unit}}",
    "range": "Range {{min}}–{{max}}{{unit}}",
    "minimum": "At least {{value}}{{unit}}",
    "maximum": "At most {{value}}{{unit}}",
    "exclusiveMinimum": "Greater than {{value}}{{unit}}",
    "exclusiveMaximum": "Less than {{value}}{{unit}}",
    "exactItems": "Item count: {{count}}",
    "minItems": "Minimum items when provided: {{count}}",
    "maxItems": "Maximum items: {{count}}",
    "minLength": "Minimum characters: {{count}}",
    "maxLength": "Maximum characters: {{count}}",
    "multipleOf": "Multiples of {{value}}{{unit}}",
    "pattern": "See JSON source for the full format constraint",
    "unique": "Items must be unique",
    "stringOrList": "Enter a single string or an ordered array of strings.",
    "binary": "Binary data",
    "stringOrListType": "String / list of strings",
    "types": {
      "string": "String",
      "integer": "Integer",
      "number": "Number",
      "boolean": "Boolean",
      "object": "Object",
      "array": "List",
      "null": "Null"
    },
    "link": "URL",
    "typedList": "List ({{type}})",
    "multipleFormats": "Multiple formats",
    "mediaSource": "Enter a public URL or select an uploaded asset ID.",
    "mediaSourceType": "URL / Asset ID",
    "role": {
      "first_frame": "First frame",
      "last_frame": "Last frame",
      "reference_image": "Reference image",
      "reference_video": "Reference video",
      "reference_audio": "Reference audio"
    },
    "secondsUnit": "s",
    "descriptions": {
      "geminiContentsHistory": "Full Gemini contents history. When provided, it replaces automatic message and media assembly.",
      "geminiFunctionConfig": "Shorthand for tool_config.function_calling_config.",
      "geminiToolConfig": "Gemini ToolConfig including functionCallingConfig or function_calling_config, mode, and allowedFunctionNames.",
      "geminiTools": "Gemini tools using REST functionDeclarations or SDK function_declarations.",
      "geminiThoughtParts": "Thinking content returned in thought parts.",
      "geminiFunctionCalls": "Gemini function calls containing name, args, and optionally id.",
      "geminiContents": "Ordered Gemini contents with roles and parts.",
      "geminiContent": "A provider-native Gemini Content object containing a role and parts.",
      "generationSettings": "Generation settings supported by this model.",
      "geminiSharedOutputTokens": "Maximum response and thinking tokens within the shared input and output context.",
      "thinkingLevel": "Amount of reasoning the model should perform before returning its response.",
      "geminiIncludeThoughts": "Whether to include thought parts in the response. This does not enable or disable reasoning.",
      "geminiSseFraming": "Use SSE framing for streaming Gemini responses.",
      "mediaLimits": "Request body limit: 64 MB. Media duration, dimensions and size are validated upstream.",
      "aspectRatio": "Requested output aspect ratio.",
      "resolution": "Requested output resolution.",
      "duration": "Requested output duration in seconds.",
      "videoPrompt": "Describe the subject, action, camera movement, and style of the video.",
      "imagePrompt": "Describe the image to generate or the requested change to an input image.",
      "imageInputs": "Image inputs; assign a role when the model exposes role-specific behavior.",
      "videoInputs": "Video inputs; assign a role when the model exposes role-specific behavior.",
      "httpVideoSizeLimit": "Video files supplied by HTTP URL must not exceed 15 MB (15,000,000 bytes). Compress larger videos or supply a supported Google Cloud Storage URI.",
      "audioInputs": "Audio inputs; assign a role when the model exposes role-specific behavior.",
      "userMessage": "User message or instruction to send to the language model.",
      "includeAudio": "Whether the generated output should include audio.",
      "stream": "Whether to stream response events as they are generated.",
      "seed": "Seed used to make generation more reproducible.",
      "speech": "Text to synthesize as speech.",
      "voice": "Voice identifier used for speech generation.",
      "outputCount": "Number of outputs to generate.",
      "negativePrompt": "Describe content, styles, or artifacts that the model should avoid.",
      "outputFormat": "Requested output media format.",
      "systemPrompt": "System instructions supplied separately from the user message.",
      "anthropicSystem": "System instructions or context supplied separately from the user message.",
      "publicModelId": "The public Nexra Model ID.",
      "anthropicMessages": "The Anthropic Messages protocol message list.",
      "clientTools": "Tool definitions executed by the client.",
      "toolChoice": "Tool selection strategy.",
      "claudeThinking": "Claude thinking configuration.",
      "outputEffort": "Output format and effort configuration.",
      "anthropicStream": "Whether to return an Anthropic SSE event stream.",
      "maxOutputTokens": "The maximum number of output tokens allowed for this generation.",
      "nativeResponse": "Protocol-native response; streaming requests return events defined by that protocol.",
      "claudeMaxOutputTokens": "Maximum output tokens, up to 128,000 for this model.",
      "claudeWebSearch": "Allow the model to invoke Anthropic's server-side web search tool.",
      "claudePromptCache": "Mark reusable prompt content for Anthropic prompt caching.",
      "claudeThinkingContent": "Thinking content returned when the selected thinking mode exposes it.",
      "claudeThinkingControl": "Thinking is enabled by default. It can be disabled at low, medium, or high effort; xhigh and max require it.",
      "claudeImages": "Up to 600 JPEG, PNG, GIF, or WebP images by URL or Base64. The native Claude API limits each Base64 image to 10 MB and the standard request body to 32 MB.",
      "agentSkillArtifacts": "Documents produced by Agent Skills and returned through OSS, including URL, filename, MIME type, and byte size.",
      "functionCallingOutput": "Tools requested by the model, including ID, name, and input; the caller executes them and returns tool_result.",
      "responseBody": "Response body; each response fragment in streaming NDJSON uses the same structure.",
      "effortGuidance": "Soft guidance for response depth and token use. High is the upstream default.",
      "claudeThinkingMaxTokens": "Maximum output tokens, including thinking and response text, up to 128,000.",
      "claudeThinkingSummary": "Reasoning summary returned when the request opts in to display it.",
      "sonnet55Effort": "Controls adaptive thinking depth and token use. The default is high.",
      "sonnet55Thinking": "Adaptive thinking is on by default. between_tools turns off up-front thinking and supports only low, medium, or high effort.",
      "sonnet55ToolChoice": "Sonnet 5.5 supports auto or none tool choice.",
      "gpt61SolEffort": "GPT-6.1 Sol reasoning effort: low, medium, high, xhigh, or max. The default is medium.",
      "responsesCacheKey": "Prompt cache key. Reuse it for the same prefix to improve cache hits.",
      "responsesFormat": "Text, json_object, or a JSON Schema descriptor mapped to text.format.",
      "responsesInput": "Responses text, messages, or input items.",
      "responsesInstructions": "System or developer instructions.",
      "responsesSafety": "Stable privacy-preserving user identifier, up to 64 characters.",
      "responsesStore": "Allow the upstream to store the response for continuation with previous_response_id. Disabled by default.",
      "responsesStream": "Whether to return a typed Responses SSE event stream.",
      "responsesVerbosity": "Response detail: low is concise, medium is balanced, and high is more detailed.",
      "videoUrls": "Generated video URLs.",
      "qwenImageEditModelId": "The official model ID is qwen-image-edit-plus. A registered channel import ID for this model is also accepted.",
      "qwenImageEditContent": "Provide one edit instruction and 1–3 images. Image order follows the array order.",
      "qwenImageEditPrompt": "Edit instruction, limited to 800 upstream-tokenized tokens.",
      "qwenImageEditImages": "Accepts a public URL, Data URL, or temporary oss:// URL from the same upstream account and model. Up to 3 images, 10 MB each; recommended dimensions are 384–3072 pixels.",
      "qwenImageEditSize": "Use WIDTH*HEIGHT, with each dimension from 512 to 2048 pixels. The upstream service adjusts to a nearby multiple of 16; when omitted, it follows the last input image's aspect ratio.",
      "qwenImageEditCount": "Generate 1–6 images; the default is 1.",
      "qwenImageEditNegativePrompt": "Describe unwanted content, up to 500 characters.",
      "qwenImageEditPromptExtend": "Let the upstream service improve the edit instruction.",
      "qwenImageEditWatermark": "Add the upstream watermark to the image's bottom-right corner.",
      "qwenImageEditSeed": "Generated randomly when omitted; identical seeds do not guarantee identical output.",
      "qwenImageEditTemporaryImage": "Temporary upstream image URL, typically valid for 24 hours.",
      "upstreamErrorOnly": "Returned only when the upstream service reports an error.",
      "h3LocalReferenceContent": "Provide a prompt and at least one image, video or audio reference.",
      "baiduKlingContent": "Provide a prompt, with optional first and last frames.",
      "baiduHailuoContent": "Provide a prompt or one first-frame image.",
      "baiduHailuoFastContent": "Provide one first-frame image, with an optional prompt.",
      "baiduC1Content": "Provide one prompt, optionally with up to seven named subject or background images.",
      "baiduViduContent": "Generate video using a prompt, first and last frames, or up to seven reference images.",
      "googleOmniContent": "Provide one prompt, optionally with one image to animate.",
      "googleOmniPrevious": "Reuse the previous generation for continued editing.",
      "baiduC1Reference": "Refer to this image in the prompt using @name.",
      "baiduC1Prompt": "Use @name to refer to the matching item in image_references.",
      "baiduPixVerseContent": "Provide one prompt, with optional first and last frames.",
      "baiduPixVerseStyle": "Available for text and single-image generation; unavailable with first and last frames.",
      "baiduPixVerseThinking": "Optimize the text prompt; when omitted, the model decides.",
      "baiduHailuoFirstFrame": "Publicly accessible URL of the first-frame image.",
      "baiduKlingFirstFrame": "Base64-encoded first-frame image data.",
      "baiduKlingLastFrame": "Base64-encoded last-frame image data.",
      "baiduOmniContent": "Provide a prompt, with optional reference images, first and last frames, or one reference video.",
      "baiduOmniImageBase64": "Base64-encoded image data.",
      "grokTaskContent": "Provide a prompt, first frame, reference images, or one source video for editing or extension. A prompt is optional when generating from a single first frame.",
      "grokVideoAction": "Choose edit to modify the whole video, or extend to continue from its end.",
      "grokNativeGeneration": "Generate a video. A prompt is optional with a first frame. Reference generation supports up to seven images and ten seconds of video.",
      "grokNativeEditing": "Edit the source video while preserving its duration, aspect ratio and resolution, up to 720p.",
      "grokNativeExtension": "Continue the source video by 2–10 seconds. The output includes the original video and added segment, preserving the source aspect ratio and resolution.",
      "grokOmniContent": "Combine first and last frames, pinned frames, reference images and voices. A prompt is required when no frames are provided. Pinned-frame timestamp values are in seconds.",
      "grokPrompt": "Describe the subject, action, camera movement and visual style.",
      "grokFrameInput": "Use as a first frame, last frame, or reference image for omni generation.",
      "grokPinnedFrame": "Use timestamp to specify when the image appears in the video, in seconds.",
      "grokFrameTimestamp": "Time within the video, less than duration. Keyframes cannot overlap after rounding to one-third-second intervals.",
      "grokVoiceReferences": "xAI preset voice ID. Refer to voices in order using <AUDIO_0>, <AUDIO_1> and <AUDIO_2> in the prompt.",
      "grokReferenceResolution": "Reference images, voices, last frames and pinned frames support up to 720p.",
      "grokKeyframes": "Up to four pinned frames. Times must be greater than zero and less than duration, and cannot share a one-third-second interval.",
      "grokSevenReferences": "Provide up to seven reference images in order.",
      "grokFourteenReferences": "Provide up to fourteen reference images in order.",
      "grokThreeVoices": "Provide up to three xAI preset voice IDs in order.",
      "speechBinaryOutput": "The HTTP response contains raw binary audio. The output_format query parameter selects its encoding.",
      "speechVoicePath": "The voice ID in the URL path.",
      "speechTextInput": "Provide the text to synthesize as speech.",
      "speechNativeText": "The text that will get converted into speech.",
      "speechNativeModel": "Identifier of the model that will be used, you can query them using GET /v1/models. The model needs to have support for text to speech, you can check this using the can_do_text_to_speech property.",
      "speechNativeLanguage": "Language code (ISO 639-1) used to enforce a language for the model and text normalization. If the model does not support the provided language code, it will be ignored. This parameter is not supported for multilingual_v2 models.",
      "speechNativeVoiceSettings": "Voice settings overriding stored settings for the given voice. They are applied only on the given request.",
      "speechNativeStability": "Determines how stable the voice is and the randomness between each generation. Lower values introduce broader emotional range for the voice. Higher values can result in a monotonous voice with limited emotion.",
      "speechNativeSpeakerBoost": "This setting boosts the similarity to the original speaker. Using this setting requires a slightly higher computational load, which in turn increases latency.",
      "speechNativeSimilarity": "Determines how closely the AI should adhere to the original voice when attempting to replicate it.",
      "speechNativeStyle": "Determines the style exaggeration of the voice. This setting attempts to amplify the style of the original speaker. It does consume additional computational resources and might increase latency if set to anything other than 0.",
      "speechNativeSpeed": "Adjusts the speed of the voice. A value of 1.0 is the default speed, while values less than 1.0 slow down the speech, and values greater than 1.0 speed it up.",
      "speechNativeDictionaries": "A list of pronunciation dictionary locators (id, version_id) to be applied to the text. They will be applied in order. You may have up to 3 locators per request",
      "speechNativeDictionaryId": "The ID of the pronunciation dictionary.",
      "speechNativeDictionaryVersion": "The ID of the version of the pronunciation dictionary. If not provided, the latest version will be used.",
      "speechNativeSeed": "If specified, our system will make a best effort to sample deterministically, such that repeated requests with the same seed and parameters should return the same result. Determinism is not guaranteed. Must be integer between 0 and 4294967295.",
      "speechNativePreviousText": "The text that came before the text of the current request. Can be used to improve the speech's continuity when concatenating together multiple generations or to influence the speech's continuity in the current generation.",
      "speechNativeNextText": "The text that comes after the text of the current request. Can be used to improve the speech's continuity when concatenating together multiple generations or to influence the speech's continuity in the current generation.",
      "speechNativePreviousIds": "A list of request_id of the samples that were generated before this generation. Can be used to improve the speech's continuity when splitting up a large task into multiple requests. The results will be best when the same model is used across the generations. In case both previous_text and previous_request_ids is send, previous_text will be ignored. A maximum of 3 request_ids can be send.",
      "speechNativeNextIds": "A list of request_id of the samples that come after this generation. next_request_ids is especially useful for maintaining the speech's continuity when regenerating a sample that has had some audio quality issues. For example, if you have generated 3 speech clips, and you want to improve clip 2, passing the request id of clip 3 as a next_request_id (and that of clip 1 as a previous_request_id) will help maintain natural flow in the combined speech. The results will be best when the same model is used across the generations. In case both next_text and next_request_ids is send, next_text will be ignored. A maximum of 3 request_ids can be send.",
      "speechNativeIvc": "Whether to use the IVC version of a professional voice. This may improve expressiveness and reduce latency.",
      "speechNativeNormalization": "This parameter controls text normalization with three modes: 'auto', 'on', and 'off'. When set to 'auto', the system will automatically decide whether to apply text normalization (e.g., spelling out numbers). With 'on', text normalization will always be applied, while with 'off', it will be skipped.",
      "speechNativeLanguageNormalization": "This parameter controls language text normalization. This helps with proper pronunciation of text in some supported languages. WARNING: This parameter can heavily increase the latency of the request. Currently only supported for Japanese.",
      "speechNativeLogging": "When enable_logging is set to false zero retention mode will be used for the request. This will mean history features are unavailable for this request, including request stitching. Zero retention mode may only be used by enterprise customers.",
      "speechNativeFormat": "Output format of the generated audio. Formatted as codec_sample_rate_bitrate. So an mp3 with 22.05kHz sample rate at 32kbs is represented as mp3_22050_32. MP3 with 192kbps bitrate requires you to be subscribed to Creator tier or above. PCM and WAV formats with 44.1kHz sample rate requires you to be subscribed to Pro tier or above. Note that the μ-law format (sometimes written mu-law, often approximated as u-law) is commonly used for Twilio audio inputs.",
      "speechNativeApiKey": "Nexra API key; the gateway supplies the channel credential upstream.",
      "speechNativeBase64": "Base64 encoded audio data",
      "speechNativeAlignment": "Timestamp information for each character in the original text",
      "speechNativeNormalizedAlignment": "Timestamp information for each character in the normalized text"
    }
  },
  "exports": {
    "currentScope": "Export current filter scope",
    "currentScopeHelp": "Create an Excel workbook with summaries and details using all applied usage filters.",
    "export": "Export",
    "emptyRecords": "No export records yet. Use Export on the usage statistics page to create a file.",
    "startTime": "Start time",
    "deletingRecord": "Deleting export record",
    "deleted": "Export record deleted",
    "deleteFailed": "Deletion failed",
    "retryLater": "Please try again later",
    "preparingDownload": "Preparing download",
    "downloadWait": "The download will start automatically. Please do not click again.",
    "downloadStarted": "Download started",
    "generateFailed": "Export generation failed",
    "retrySmaller": "Try again or choose a shorter date range",
    "retryDownload": "Retry download",
    "download": "Download",
    "deleteTitle": "Delete export record",
    "confirmDelete": "Confirm deletion",
    "generatingFile": "Generating export file",
    "autoDownload": "The download will start automatically",
    "cannotExport": "Cannot export",
    "unconfirmed": "Select a matching item, verify the IDs, or clear unconfirmed input",
    "dateRequired": "Enter both the start and end of the date range",
    "dateOrder": "The start time must be earlier than the end time",
    "dateLimit": "Export up to 366 days at a time. Choose a shorter date range.",
    "format": "Format",
    "range": "Date range",
    "createdAt": "Created",
    "status": "Status",
    "actions": "Actions",
    "title": "Exports",
    "exportUsage": "Export usage",
    "exportDownload": "Export and download",
    "endTime": "End time",
    "loading": "Loading export records…",
    "loadFailed": "Could not load records. Refresh to try again.",
    "empty": "No exports yet. Use the form above to export and download.",
    "queued": "Ready to download",
    "processing": "Generating",
    "succeeded": "Generated",
    "failed": "Failed",
    "expired": "Expired",
    "modelCount": "Models: {{count}}",
    "userCount": "Users: {{count}}",
    "deleteDescription": "Delete record {{id}}? This cannot be undone. Files already downloaded to your device are unaffected."
  },
  "filters": {
    "user": "User",
    "userAccount": "User account",
    "exportModelsPlaceholder": "All if blank; search model or ID, separate multiple IDs with commas",
    "exportUsersPlaceholder": "All if blank; search email, username or ID, separate multiple IDs with commas",
    "selectionLimit": "Select up to {{count}} items. Remove a selection before adding another.",
    "invalidIds": "Enter valid internal IDs, up to {{count}} at a time.",
    "missingIds": "IDs not found: {{ids}}. Check them and try again.",
    "confirmFailed": "Could not verify IDs. Please try again.",
    "search": "Search {{name}}",
    "select": "Select {{name}}",
    "options": "{{name}} filter options",
    "selectedCount": "Selected: {{count}}",
    "searchOrBrowse": "Search or browse the list",
    "selectedOnly": "Selected",
    "clearSelection": "Clear selection",
    "list": "{{name}} list",
    "confirming": "Verifying…",
    "confirmIds": "Verify entered IDs",
    "viewSelected": "View selected {{name}} ({{count}})",
    "selected": "Selected {{name}}",
    "itemCount": "Items: {{count}}",
    "remove": "Remove {{name}}"
  },
  "channels": {
    "modelManagement": "Model management",
    "credentialsExpired": "Credentials expired",
    "credentialsInvalid": "Invalid credentials",
    "connectionError": "Connection issue",
    "lastCheckPassed": "Last check passed",
    "notChecked": "Not checked",
    "apiKey": "API key",
    "bearerToken": "Access token",
    "serviceAccount": "Service account JSON",
    "edit": "Edit channel",
    "add": "Add channel",
    "editDescription": "Manage connection settings, credentials, and available models.",
    "addDescription": "Choose a channel type, then configure its connection and models.",
    "closeEditor": "Close channel editor",
    "type": "Channel type",
    "custom": "Custom · third-party / private deployment",
    "typeImmutable": "Channel type cannot be changed after creation.",
    "typeHelp": "Choose an official provider or a custom compatible endpoint.",
    "name": "Channel name",
    "namePlaceholder": "e.g. Primary production channel",
    "customHelp": "Custom channels use OpenAI-compatible endpoints. The Anthropic type uses the official service address.",
    "enable": "Enable this channel",
    "enabledHelp": "Allow requests through this channel",
    "disabledHelp": "Disable temporarily and keep configuration",
    "maxActiveJobs": "Async task concurrency limit",
    "maxActiveJobsPlaceholder": "Blank means unlimited",
    "maxActiveJobsHelp": "Applies only to this channel's asynchronous tasks. Leave blank for no limit.",
    "invalidMaxActiveJobs": "The concurrency limit must be a positive integer",
    "connectionCredentials": "Connection and credentials",
    "apiAddress": "API address",
    "defaultAddress": "Defaults to the official address. Replace it for a third-party service. Use HTTPS without credentials or a model-specific path.",
    "savedCredentials": "✓ Credentials saved",
    "missingCredentials": "Credentials pending",
    "missingCredentialsHelp": "This channel was promoted from test. Enter credentials, save, then validate and enable it.",
    "keepCredentialsHelp": "Leave blank to keep saved credentials. Enter new credentials only to replace them.",
    "keepAccount": "Leave blank to keep the existing service account",
    "accountPlaceholder": "Paste the complete Google service account JSON",
    "keepSecret": "Leave blank to keep existing credentials",
    "secretPlaceholder": "Credentials from the channel",
    "hideInputSecret": "Hide entered credentials",
    "showInputSecret": "Show entered credentials",
    "hideSecret": "Hide credentials",
    "showSecret": "Show credentials",
    "saveApplies": "Connection and model selection take effect after saving",
    "encrypted": "Credentials are stored encrypted",
    "saving": "Saving…",
    "save": "Save channel",
    "syncingModels": "Syncing upstream models",
    "modelsSynced": "Upstream models synced",
    "syncFailed": "Failed to sync upstream models",
    "retryLater": "Please try again later",
    "importing": "Importing model",
    "modelImported": "Model imported",
    "importFailed": "Failed to import model",
    "modelsDescription": "Sync the upstream list and select models allowed on this channel.",
    "syncing": "Syncing…",
    "resync": "Sync again",
    "sync": "Sync upstream models",
    "syncPersists": "Sync saves the list immediately. New supplies are disabled by default; cancelling the editor does not undo a sync.",
    "notSynced": "Upstream list not yet synced",
    "noDiscovery": "This channel has no model-list endpoint. Choose configured entries or enter upstream model IDs manually.",
    "saveBeforeSync": "Save connection settings and credentials before syncing, or enter upstream model IDs manually first.",
    "connectionChanged": "Connection settings have changed. Save the channel before syncing from the new address.",
    "searchModels": "Search channel models",
    "searchModelsPlaceholder": "Model ID or name",
    "selectResults": "Select all results",
    "selectAll": "Select all",
    "clearAll": "Clear all",
    "loadingModels": "Loading saved models…",
    "selectedModels": "Selected models",
    "supportedModels": "Models supported by this channel",
    "unmatched": "No matching catalog model",
    "import": "Import",
    "confirmImport": "Confirm import",
    "imported": "Imported",
    "discovered": "Discovered upstream",
    "manual": "Added manually",
    "noMatchedModels": "No matching models",
    "emptyModels": "No models yet. Sync upstream models or add them manually.",
    "importedMappings": "Imported model mappings",
    "upstreamModel": "Upstream model",
    "nexraModel": "Nexra model",
    "costStatus": "Cost status",
    "pendingProtocols": "Imported; endpoint protocols need confirmation",
    "configured": "Configured",
    "missing": "Missing",
    "manualIds": "Enter upstream model IDs manually",
    "manualHelp": "Use this when the upstream has no model list or uses custom deployment names.",
    "manualPlaceholder": "Upstream model IDs, separated by commas",
    "upstreamRouting": "Upstream routing",
    "supplyDescription": "Choose an upstream channel and model, then configure endpoint priority and weight.",
    "credentialOperationFailed": "Credential operation failed",
    "saveFailed": "Failed to save channel",
    "saved": "Channel saved",
    "checkingConnection": "Checking channel connection",
    "checkFailed": "Channel check failed",
    "connectionHealthy": "Channel connection is healthy",
    "connectionUnhealthy": "Channel connection has an issue",
    "channelProvider": "Channel / provider",
    "models": "Models",
    "connection": "Connection",
    "credentials": "Credentials",
    "hidePlaintext": "Hide plaintext credentials",
    "showPlaintext": "Show plaintext credentials",
    "checking": "Checking",
    "checkRetry": "Check failed. Please retry.",
    "maintain": "Manage channel",
    "checkPending": "Checking…",
    "check": "Check connection",
    "verifyViaModel": "Verify the connection by testing a connected model",
    "noIndependentCheck": "Independent check unavailable",
    "create": "＋ New channel",
    "search": "Search channels",
    "searchPlaceholder": "Channel, provider, or API address",
    "allProviders": "All providers",
    "allStatuses": "All statuses",
    "enabled": "Enabled",
    "degraded": "Degraded",
    "disabled": "Disabled",
    "noMatches": "No matching channels",
    "copied": "Credentials copied",
    "copyPlaintext": "Copy plaintext credentials",
    "copy": "Copy credentials",
    "region": "Region",
    "mediaStorageRegion": "Generated media storage region",
    "mediaStorageRegionHelp": "Choose the domestic or global bucket for generated images and videos according to your data storage requirements.",
    "mediaStorageRegionCn": "Domestic bucket (cn)",
    "mediaStorageRegionGlobal": "Global bucket (global)",
    "openaiCompatible": "OpenAI-compatible endpoint",
    "compatibleAddress": "Enter the service API base URL, e.g. https://ai.example.com/v1. For OpenAI-compatible third-party services and private deployments.",
    "azureAddress": "Enter the Azure resource URL, e.g. https://your-resource.openai.azure.com, without a deployment-specific path.",
    "foundryAddress": "Enter the Foundry project URL, e.g. https://your-resource.services.ai.azure.com/api/projects/your-project.",
    "projectId": "Project ID",
    "location": "Location",
    "workspaceId": "Workspace ID",
    "awsClaudeAddress": "Enter the endpoint provided by Claude on AWS.",
    "bedrockAddress": "Enter the Bedrock Runtime URL for the selected region. This channel type uses a Bedrock API key.",
    "volcengineArk": "Volcengine Ark",
    "volcengineSpeech": "Volcengine Speech",
    "alibabaBailian": "Alibaba Cloud Model Studio",
    "h3Address": "Enter the base URL of your self-hosted H3 service. HTTP and HTTPS are supported; HTTP transmits the session in plaintext.",
    "h3PartnerAddress": "Enter the base URL of your H3 Partner API service. HTTP and HTTPS are supported.",
    "incompleteCredentials": "Complete all required credentials, or leave all fields blank to keep the existing credentials.",
    "invalidServiceAccount": "Service account JSON must include project_id, client_email, and private_key.",
    "recognizedAccount": "Recognized service account: {{email}}",
    "modelCount": "Models: {{count}}",
    "importedHint": "{{id}}; manage protocols, status, and cost in model supplies",
    "selectionLimit": "Select no more than 5,000 models. Narrow your selection.",
    "invalidModelIds": "Model IDs must be at most 320 characters. Select no more than 5,000 models.",
    "selectedCount": "Selected {{count}} / {{total}} models",
    "lastSynced": "Last synced {{at}}",
    "resultsTruncated": "Showing the first 100 results. Search to find other models; Select all includes all {{count}} results.",
    "removeModel": "Remove {{id}}",
    "selectModel": "Select {{id}}",
    "moreSelected": "{{count}} more",
    "exactMatch": "Exact match: {{id}}",
    "suggestedMatch": "Suggested: {{id}}",
    "configuredProtocols": "Configured protocols: {{protocols}}",
    "partialList": "The upstream list may be incomplete. ",
    "selectionSaveHint": "Selections take effect after saving. Manage imported model availability, protocols, and costs in model management.",
    "checkStatus": "Check connection · {{status}}"
  },
  "validity": {
    "indefinite": "No expiry",
    "active": "In effect",
    "soon": "Effective soon",
    "upcoming": "Not yet effective"
  },
  "overview": {
    "scrollUp": "Scroll {{label}} up",
    "scrollDown": "Scroll {{label}} down",
    "measured": "Measured",
    "carried": "Last known result",
    "expired": "Expired",
    "noObservation": "No observations",
    "none": "None",
    "collectionGap": " · Collection gaps",
    "hourScroll": "1 hour per cell · scroll horizontally",
    "hourNow": "1 hour per cell · now",
    "legend": "Legend",
    "measuredSuccess": "Measured success",
    "mixed": "Mixed results",
    "measuredFailure": "Measured failure",
    "carriedSuccess": "Last known success",
    "carriedFailure": "Last known failure",
    "unknownExpired": "Unknown / expired",
    "gapLegend": "Dashed: collection gap",
    "readFailed": "Failed to load. Stale data is hidden; please retry.",
    "unavailable": "Operational data is unavailable. Please retry.",
    "loading": "Loading operational data…",
    "title": "Platform operations",
    "refresh": "Refresh metrics",
    "registeredModels": "Registered models",
    "databaseTotal": "Total database count",
    "activeChannels": "Active channels",
    "channelStates": "Normal {{normal}} · Issues {{abnormal}} · Disabled {{disabled}}",
    "availabilityNote": "See measured endpoint availability below",
    "tasks24h": "Async tasks · 24h",
    "recentErrors": "Recent errors",
    "period24h": "24h",
    "period7d": "7 days",
    "sampleInterval": "Sampled every 30s · 1 hour per cell",
    "sampleSource": "Sampling environment: {{source}}",
    "noCore": "No core service observations",
    "activeTasks": "Active long-running tasks",
    "activeTasksWithCount": "{{label}} (total {{count}})",
    "noRecentTasks": "No recent task records",
    "manageTasks": "Manage tasks →",
    "taskList": "Active task list",
    "noTasks": "No tasks are currently running",
    "liveTail": "Recent gateway requests",
    "httpResponse": "HTTP response",
    "recentLink": "View recent →",
    "requestList": "Recent gateway request list",
    "channelProbes": "Upstream channel probes",
    "manageChannels": "Manage channels →",
    "probeList": "Upstream channel probe list",
    "channelRouteCounts": "Models: {{models}} · Routes: {{routes}}",
    "channelObservation": "Channel observation: {{state}} (business requests and active probes)",
    "probeReady": "Ready to probe",
    "probeReadyCount": "{{ready}}/{{total}} routes ready for probing",
    "observedSuccess": "Observed success",
    "collapseProbes": "Collapse",
    "showProbes": "Show {{count}} routes",
    "noTargets": "No model channel endpoints",
    "shortcuts": "Operations shortcuts",
    "pricingTitle": "Global sales pricing",
    "pricingDescription": "Manage base multipliers and recalculate published prices",
    "errorsTitle": "Investigate gateway 4xx/5xx errors",
    "errorsDescription": "Diagnose upstream disconnections and request timeouts",
    "monitoringBudget": "Monitoring and probe budget",
    "noBudget": "No budget configured. Automatic paid probes are disabled.",
    "monitoringHelp": "Monitoring details",
    "help": "Details",
    "historyWindow": "History window",
    "last24h": "Last 24 hours",
    "last7d": "Last 7 days",
    "probeSubmitFailed": "Failed to submit probe",
    "retry": "Please retry",
    "autoProbeEnabled": "Automatic probes configured",
    "autoProbeDisabled": "Automatic probes disabled",
    "businessRate": "Request success rate",
    "probeRate": "Active probe success rate",
    "observationSummary": "{{label}} {{rate}} · {{count}} observations",
    "observationDetails": "Observation details",
    "configureTemplate": "Configure template",
    "runProbe": "Run probe",
    "history": "History",
    "costRefreshing": "Cost is updating or unavailable. Stale amounts are hidden.",
    "costPaused": " · Paused pending cost confirmation",
    "probeReadFailed": "Failed to load probe results. Please retry.",
    "unknownCost": "Unknown cost",
    "probeHistoryLoading": "Loading latest probe history…",
    "noProbeHistory": "No probe history",
    "saveFailed": "Failed to save configuration",
    "intervalSeconds": "Probe interval without valid request results (seconds)",
    "timeoutSeconds": "Total timeout (seconds)",
    "runBudget": "Budget per probe",
    "templateVersion": "Template version",
    "enableProbes": "Enable automatic probes",
    "requestTemplateHelp": "Request template (including required parameters and reference media)",
    "requestTemplate": "Request template",
    "maxUsageHelp": "Maximum usage (normalized usage JSON; only required when automatic estimation is unavailable)",
    "maxUsage": "Maximum usage",
    "saveConfig": "Save configuration",
    "setBudget": "Set daily budget",
    "operationFailed": "Operation failed",
    "cny": "CNY",
    "budgetCurrency": "Budget currency",
    "dailyLimitCny": "Daily limit (CNY)",
    "dailyLimit": "Daily limit",
    "amountPlaceholder": "Amount",
    "confirmCost": "Confirm actual cost",
    "upstreamCostPlaceholder": "Enter confirmed upstream cost",
    "settle": "Confirm settlement",
    "noSamples": "No samples",
    "bucket": "{{start}} — {{end}} · {{evidence}} · Requests: {{businessSuccess}} succeeded / {{businessFailure}} failed · Probes: {{probeSuccess}} succeeded / {{probeFailure}} failed {{core}} · Latest evidence: {{latest}}{{gap}}",
    "coreSamples": "· Core: {{success}} succeeded / {{failure}} failed ({{expected}} expected)",
    "taskSummary": "Success rate {{rate}} · {{count}} cancelled",
    "recentRequestCount": "Last 5 minutes · {{count}} requests",
    "coreHealth": "Core services · {{period}} health",
    "gatewaySummary": "QPS {{qps}} · API P99 {{p99}}",
    "taskCounts": "{{running}} running · {{queued}} queued",
    "callbackCounts": "{{pending}} pending · {{retrying}} retrying",
    "modelCount": "{{count}} models",
    "failureCount": "{{count}} failures",
    "historySummary": "History from {{start}} · Final request success rate {{rate}} ({{count}} samples / 5 minutes)",
    "latencySummary": "API latency: P95 {{p95}} · P99 {{p99}} · {{count}} samples. Async tasks include only request acceptance latency.",
    "callbackSummary": "Callbacks: {{pending}} pending · {{retrying}} retrying · {{failed}} failed · {{delivered}} delivered in 24h",
    "budgetSummary": "{{currency}} · Daily limit {{limit}} · Settled {{settled}} · Reserved {{reserved}}",
    "sparkline": "{{start}} — {{end}} · {{samples}} · Sampled every 30s{{gap}}",
    "sampleRate": "Success rate {{rate}} ({{success}}/{{count}})",
    "notReady": "Unconfigured / paused: {{state}}",
    "probeInterval": "Probe every {{hours}} hours without valid request results",
    "probeResult": "Probe {{id}} · {{status}} · {{stage}}",
    "reserved": "Reserved {{amount}}",
    "upstreamTask": " · Upstream {{id}}",
    "stats": "{{label}} {{rate}} · {{samples}} samples / {{hours}} hours · Rate limited {{limited}} · Region restricted {{restricted}} · Excluded {{excluded}}",
    "core": {
      "gateway": "Gateway routing",
      "database": "Postgres database",
      "restate": "Restate orchestration",
      "webhook": "Callback delivery"
    },
    "samplingInterrupted": "Sampling interrupted",
    "historicalSampleRate": "Historical sample success rate; gray means no samples"
  },
  "common": {
    "realtimeDisconnected": "Live updates are disconnected. Showing the last available data.",
    "newRecordsAvailable": "New records available. Refresh to view",
    "networkError": "Network connection failed. Please try again.",
    "pagination": "Pagination",
    "pageNumber": "Page {{page}}",
    "refreshing": "Refreshing…",
    "loading": "Loading…",
    "loadFailed": "Failed to load",
    "copy": "Copy",
    "copied": "Copied",
    "reset": "Reset",
    "more": "More",
    "less": "Less",
    "selectPlaceholder": "Select",
    "dash": "—",
    "default": "Default",
    "on": "On",
    "off": "Off",
    "automatic": "Auto",
    "choose": "Choose",
    "randomUnset": "Random (omit)",
    "noCompressionUnset": "No compression (omit)",
    "followInputUnset": "Unset (follow input image)",
    "unspecified": "Not specified",
    "setField": "Set {{title}}."
  },
  "usageDocs": {
    "title": "Usage API Reference",
    "toc": "On this page",
    "endpoint": "Endpoint",
    "description": "Description",
    "parameter": "Parameter",
    "rule": "Rule",
    "field": "Field",
    "httpStatus": "HTTP status",
    "errorCode": "Error code",
    "sections": {
      "authentication": "Authentication and permissions",
      "endpoints": "Endpoints",
      "parameters": "Query parameters",
      "fields": "Response fields",
      "examples": "Request and response examples",
      "pagination": "Pagination and freshness",
      "errors": "Errors and handling"
    },
    "authentication": "Active administrator account with a verified email.",
    "keyScope": "Read-only global queries; the API Key can still call models.",
    "headers": "zh-CN / en; default en.",
    "endpointDescriptions": {
      "summary": "Requests, outcomes, token/media usage and CNY amounts; time and model/API Key grouping.",
      "details": "Per-request attribution, usage evidence, charge amounts and breakdowns, with cursor pagination.",
      "anomalies": "Billing anomaly counts, grouped by model, channel or provider."
    },
    "parameterDescriptions": {
      "start": "Required ISO-8601 instant with timezone and at most three fractional digits. Inclusive, matched by request received_at.",
      "end": "Required, after start and exclusive; at most {{maxDays}} days.",
      "timeZoneOffsetMinutes": "Integer -720..840, default 0 (UTC); use 480 for UTC+08:00. Affects buckets only.",
      "groupBy": "Required on summary: {{groups}}. At most one time granularity; no duplicates.",
      "limit": "Summary: 1..{{summaryLimit}}; details: 1..{{detailsLimit}}; default {{defaultLimit}}.",
      "cursor": "Summary/details only. Omit on the first page; pass nextCursor with unchanged query conditions.",
      "userIds": "Account ID list, at most {{filterLimit}} entries.",
      "apiKeyIds": "API Key database UUID list, at most {{filterLimit}} entries.",
      "providerIds": "Provider database UUID list, at most {{filterLimit}} entries.",
      "channelIds": "Channel database UUID list, at most {{filterLimit}} entries.",
      "modelIds": "Model database UUID list, at most {{filterLimit}} entries.",
      "operations": "Operation name list, e.g. language.generate; at most {{filterLimit}} entries.",
      "requestStatuses": "received / accepted / running / succeeded / rejected / failed / cancelled; at most {{filterLimit}} entries.",
      "usageSources": "{{sources}}. estimated is excluded from reporting.",
      "normalizationStatuses": "{{normalization}}. partial is reserved.",
      "ratingStatuses": "{{rating}}.",
      "upstreamModelId": "One exact upstream model ID.",
      "breakdown": "Anomaly summary only: provider / channel / model, at most two."
    },
    "fieldDescriptions": {
      "group": "Selected dimensions: time is a UTC bucket-start instant, other fields are database IDs.",
      "requests": "total/succeeded/failed counts. Accepted/running requests count toward total. Cancellation and required delivery failure count as failures.",
      "usage": "Evidence presence, missing counts, sources and normalization counts. Missing evidence is not zero usage.",
      "rating": "Counts of billed/unsettled/billing_failed/unpriced/usage_missing. billed can include refunded charges; operating amounts count succeeded charges only.",
      "tokens": "requestsWithTokenMetrics counts token evidence. applicable is null for time buckets or without model grouping; false means the model has no applicable token pricing.",
      "metrics": "Normalized metric quantities summed across dimensions. A missing key is unmetered or not applicable; a present 0 is measured zero.",
      "amounts": "sale/cost/gross entries in CNY, with amount as decimal strings up to 8 fraction digits. Only succeeded charges contribute. Missing cost/rates are not zero; only gross can be negative.",
      "costReporting": "reported/missingCost/missingRate counts reveal procurement-cost and frozen-FX coverage for succeeded charges.",
      "nextCursor": "Summary/details return null at the end. Otherwise request the next page with unchanged query parameters. Empty windows return data: [].",
      "details": "Detail rows contain requestId/requestKey, receivedAt, status, HTTP/duration/error context, account/Key/model/route IDs, usage and nullable charge. usage has rawUsage/normalizedUsage; charge has decimal amounts, frozen reporting FX, discountBps and breakdown.",
      "categories": "Anomaly category/count/firstOccurredAt/lastOccurredAt. usage_missing applies only to succeeded requests and can differ from summary usage.missing.",
      "breakdowns": "Requested anomaly category/dimension/nullable dimensionId/count breakdowns."
    },
    "exampleTitles": {
      "summary": "Summary response",
      "details": "Detail response",
      "anomalies": "Anomaly summary response"
    },
    "pagination": "No cross-page snapshot; overwrite previous aggregates when re-reading recent windows.",
    "freshness": "Usage and settlement update asynchronously. Settled charges use frozen evidence; unsettled requests use current-attempt evidence.",
    "account": "Account",
    "permissions": "Permissions",
    "authHeader": "Bearer <API Key> or x-api-key: <API Key>.",
    "baseUrl": "API origin without a trailing slash.",
    "apiKey": "Administrator API Key.",
    "snapshot": "Page snapshot",
    "dataFreshness": "Freshness",
    "timeBuckets": "Time buckets",
    "sparseBuckets": "Buckets without requests are omitted."
  },
  "documentation": {
    "navigation": "Documentation navigation"
  },
  "nav": {
    "documentation": "API Docs",
    "usageDocs": "Usage API",
    "errorDocs": "Error Reference",
    "homeAria": "Nexra home",
    "mainAria": "Main",
    "home": "Home",
    "playground": "Playground",
    "models": "Models",
    "requests": "Requests",
    "admin": "Admin",
    "login": "Sign in",
    "settings": "Settings",
    "signOut": "Sign out",
    "language": "Language",
    "languageZh": "中文",
    "languageEn": "English",
    "accountMenu": "Account menu",
    "apiKeys": "API keys",
    "signedInAs": "Signed in as",
    "loginEntry": "Login"
  },
  "auth": {
    "wechatWaiting": "Scan the QR code with WeChat in the new window.",
    "socialPopupBlocked": "Allow authorization pop-ups in your browser, then try again.",
    "socialFailed": "Sign-in failed. Please try again.",
    "socialExpired": "This authorization has expired. Please sign in again.",
    "socialNotConfigured": "Sign-in is not configured. Contact your administrator.",
    "socialSecurity": "Secure sign-in. No password to remember.",
    "socialCreateAccount": "Your account is created on your first sign-in.",
    "socialProductDescription": "Image, video, and language models, all connected.",
    "socialHeadline": "One place.\nMore possibilities.",
    "socialDescription": "Choose your way in. Pick up where inspiration starts.",
    "socialTitle": "Sign in to Nexra",
    "wechatSignIn": "Continue with WeChat",
    "googleSignIn": "Continue with Google",
    "googleWaiting": "Complete Google authorization in the new window.",
    "signInTitle": "Sign in",
    "signUpTitle": "Create account",
    "description": "Models, tasks, and request data are visible only to this account.",
    "name": "Name",
    "email": "Email",
    "password": "Password",
    "submitting": "Submitting…",
    "signIn": "Sign in",
    "signUp": "Sign up",
    "needAccount": "Need an account? Sign up",
    "haveAccount": "Already have an account? Sign in",
    "feishuSignIn": "{{enterprise}} · Feishu",
    "feishuWaiting": "Authorize with your account from the selected enterprise in the new window.",
    "feishuEmployeeRequired": "Use an active employee account from the selected enterprise with access to this application.",
    "feishuUnavailable": "Enterprise Feishu login is unavailable. Try again later or contact the application owner.",
    "cancelFeishu": "Cancel Feishu login"
  },
  "dashboard": {
    "title": "Home",
    "welcomeBack": "Welcome back, {{name}}",
    "guestWelcome": "Start using Nexra models",
    "quickStart": "Quick start",
    "quickStartHint": "Start from models that are already connected and runnable.",
    "createTitle": "Create with AI",
    "createHint": "Run connected task models without writing integration code.",
    "sandboxTitle": "Nexra playground",
    "sandboxHint": "Configure and run media generation tasks",
    "browseTitle": "Browse models",
    "browseHint": "See the catalog and parameter contracts",
    "recentTitle": "Recent activity",
    "recentHint": "Inspect requests, latency, and errors",
    "signInTitle": "Sign in to console",
    "signInHint": "View tasks, requests, and usage",
    "exploreTitle": "Explore latest models",
    "exploreHint": "See the newest published capabilities in the catalog.",
    "browseAllHint": "Search all published models",
    "noPublished": "No published models yet",
    "shelfAria": "Home models",
    "latestModels": "✦ Latest models",
    "recentlyUsed": "↻ Recently used",
    "viewAll": "View all →",
    "noRecent": "No recently used models",
    "noRecentDetail": "Models you run in the playground will appear here.",
    "latestResults": "Latest generations",
    "latestResultsHint": "Recent image, video, and audio task results.",
    "showPreview": "Show previews",
    "previewHidden": "Generation previews are hidden. Open request history to inspect them.",
    "noResults": "No generations yet",
    "noResultsDetail": "Run your first model in the playground."
  },
  "notFound": {
    "title": "Page not found",
    "detail": "Return home to keep browsing.",
    "backHome": "Back home"
  },
  "explore": {
    "title": "Models",
    "modelCount": "{{count}} models",
    "modelCount_one": "{{count}} model",
    "modelCount_other": "{{count}} models",
    "subtitle": "Explore model capabilities, API documentation, and pricing.",
    "searchPlaceholder": "Search name, ID, or capability…",
    "sortAria": "Sort",
    "sortName": "Name (A-Z)",
    "all": "All",
    "audioTab": "Speech & audio",
    "emptyTitle": "No models match these filters",
    "emptyDetail": "Try clearing filters or changing your search.",
    "resetFilters": "Reset filters",
    "inputTypes": "Input types",
    "developers": "Developers",
    "text": "Text",
    "image": "Image",
    "video": "Video",
    "audio": "Audio",
    "file": "File",
    "showMore": "Show more",
    "showLess": "Show less",
    "sortDefault": "Default order",
    "copyModelId": "Copy model ID",
    "copyFailed": "Could not copy model ID",
    "modelSummary": "{{name}} · {{operation}}",
    "outputTypes": "Output types",
    "protocols": "Protocols",
    "unavailable": "No available endpoints",
    "endpointCount": "{{count}} endpoints",
    "endpointCount_one": "{{count}} endpoint",
    "endpointCount_other": "{{count}} endpoints",
    "pricing": "Pricing",
    "apiDocs": "API docs",
    "details": "Details",
    "successHistory": "Request success over the last 24 hours",
    "successRate": "24h success rate",
    "noRequests": "No requests",
    "noStatistics": "No statistics",
    "successSample": "{{rate}}% · {{succeeded}} / {{total}} requests",
    "filters": "Model filters",
    "selectedFilters": "Model filters ({{count}} selected)",
    "modelType": "Model category"
  },
  "studio": {
    "videoOutputChoice": "Video output",
    "videoOutputNumber": "Video {{number}}",
    "videoOutputRoles": {
      "mask": "Black-and-white mask",
      "tracking-preview": "Colour tracking preview"
    },
    "tabs": {
      "playground": "Playground",
      "api": "API",
      "examples": "Examples",
      "pricing": "Pricing",
      "requests": "History"
    },
    "input": "Input",
    "result": "Result",
    "form": "Form",
    "preview": "Preview",
    "inputView": "Input view",
    "jsonInput": "JSON input",
    "jsonObjectRequired": "Enter a JSON object, not an array, text, number, boolean, or null.",
    "jsonSyntaxError": "Invalid JSON. Check quotes, commas, and brackets.",
    "editMultipleMessagesJson": "Edit multiple messages in JSON.",
    "codeExample": "Code example (read-only)",
    "copy": "Copy",
    "copied": "Copied",
    "copyUrl": "Copy URL",
    "copyModelId": "Copy model ID",
    "favorite": "Save",
    "unfavorite": "Saved",
    "openInSandbox": "Playground",
    "download": "Download",
    "run": "Run",
    "reset": "Reset",
    "generating": "Generating…",
    "taskReadRetrying": "Task status is temporarily unavailable. Retrying automatically; please don't submit again.",
    "taskReadUnavailable": "Task status is temporarily unavailable. Refresh to retry; please don't submit again.",
    "ready": "Waiting to run",
    "completed": "Completed",
    "failed": "Failed",
    "additionalSettings": "More parameters",
    "more": "More",
    "less": "Less",
    "prompt": "Prompt",
    "duration": "Duration",
    "approximateDuration": "about {{value}}{{unit}}",
    "fixedDuration": "Fixed {{value}}",
    "resolution": "Resolution",
    "seedanceDraft": "Draft preview (480p)",
    "seedanceDraftHint": "Generate a 480p preview first. The preview and final 1080p video are separate paid tasks.",
    "seedanceDraftReady": "Draft preview is ready",
    "seedanceDraftBilling": "Generate the 1080p final video from this preview within 7 days. This starts a separate paid task on the same channel.",
    "seedanceGenerateFinal": "Generate final 1080p video",
    "seedanceDraftExpired": "Preview expired — create a new Draft",
    "aspectRatio": "Aspect ratio",
    "automatic": "Auto",
    "imageBadge": "Img",
    "videoBadge": "Video",
    "audioBadge": "Audio",
    "outputHint": "Adjust parameters on the left, then click Run.",
    "waitingForResult": "The request is in progress. Results will appear here.",
    "chargedByUsage": "Billed by actual usage.",
    "requestDuration": "Request took {{duration}}",
    "version": "Version",
    "switchVersion": "Switch model version",
    "modelDescriptionFallback": "{{name}} supports {{modality}} capabilities.",
    "schema": "Schema",
    "analytics": "Analytics",
    "modelDetails": "Model details",
    "videoFailed": "Video generation failed",
    "noVideo": "No video returned",
    "imageFailed": "Image generation failed",
    "noImage": "No image returned",
    "llmsTxt": "LLMs.txt",
    "openLlmsTxt": "Open LLMs.txt",
    "resultView": "Result view",
    "pause": "Pause",
    "play": "Play",
    "muted": "Muted",
    "audioOn": "Native audio on",
    "saveOrShare": "Save or share the result",
    "close": "Close",
    "zoomPreview": "Zoomed preview",
    "generatedImage": "Generated image",
    "generatedVideo": "Generated video",
    "viewOriginal": "View original",
    "generatingImage": "Generating image…",
    "generatingVideo": "Generating video…",
    "replyPlaceholder": "Continue the conversation…",
    "reply": "Follow-up message",
    "sendReply": "Send follow-up",
    "replyFailed": "Could not send the message. Please try again.",
    "toolCall": "Tool call",
    "receivingToolName": "Receiving tool name…",
    "toolExecuted": "Executed",
    "toolPending": "Requested · not executed",
    "thoughtProcess": "Reasoning",
    "generatingResponse": "Generating response…",
    "videoPoster": "Video preview",
    "generatedImageNumber": "Generated image {{count}}",
    "promptPlaceholder": "Describe the video you want to generate or edit…",
    "resetDuration": "Reset duration",
    "firstFrame": "First frame",
    "lastFrame": "Last frame",
    "pasteImageUrl": "Paste an image URL",
    "uploadOrPasteImage": "Upload an image or paste a URL",
    "uploading": "Uploading…",
    "addImage": "Add image",
    "remove": "Remove",
    "removeImage": "Remove this image",
    "removeAudio": "Remove this audio",
    "removeVideo": "Remove this video",
    "hint": "Hint",
    "mediaHint": "Drag and drop images, paste from the clipboard, or enter a URL. Formats: jpg, jpeg, png, webp, gif, avif, heic, heif.",
    "mediaHintShort": "Drag and drop images, paste from the clipboard, or enter a URL.",
    "cameraMotion": "Camera motion",
    "fixedCamera": "Fixed camera",
    "additionalHint": "Configure optional model parameters.",
    "hashHint": "Use # to reference inputs and @ to reference entities.",
    "mentionHint": "Click an asset to insert an @ reference into the prompt.",
    "refImages": "Reference images",
    "referenceAssets": "Reference assets",
    "addMedia": "Add media",
    "dropReferenceMedia": "Or drop images, video or audio here.",
    "unsupportedMedia": "This model does not support this file type.",
    "mediaCapacityReached": "The media limit has been reached. Remove an asset before adding more.",
    "previewAsset": "Preview {{name}}",
    "refVideos": "Reference videos",
    "refAudios": "Reference audios",
    "refImagesHint": "Character, scene, or style references. Multiple allowed.",
    "refVideosHint": "Reference camera motion, action, or gesture.",
    "refAudiosHint": "Reference music, rhythm, or sound effects.",
    "pasteAssetUrl": "Paste asset URL",
    "upload": "Upload",
    "uploadImage": "Upload image",
    "uploadVideo": "Upload video",
    "uploadAudio": "Upload audio",
    "dropOrPasteMedia": "Choose, drop, or paste a file",
    "dropOrPasteImage": "Choose, drop, or paste an image",
    "addUrl": "Add URL",
    "addMore": "Add more",
    "replace": "Replace",
    "uploadFailed": "Upload failed, please try again",
    "assetCount": "{{count}} assets",
    "assetCount_one": "{{count}} asset",
    "assetCount_other": "{{count}} assets",
    "insertReference": "Insert reference into prompt",
    "insertReferenceNamed": "Insert {{name}} into prompt",
    "generateAudio": "Generate audio",
    "audioOnChip": "With audio",
    "audioOffChip": "Silent",
    "useAsReference": "Use as reference video",
    "framesMode": "Keyframes",
    "mediaMode": "Reference mode",
    "refMode": "Reference",
    "lastFrameNeedsFirst": "A last frame requires a first frame.",
    "attachment": "Attachment",
    "protocolEndpoint": "Protocol endpoint",
    "systemInstruction": "System instruction",
    "systemPlaceholder": "Set role and behavior (optional)",
    "thinkingLevel": "Thinking level",
    "addFile": "Add file",
    "addUrlPlaceholder": "Add an image, document, or URL",
    "documentHint": "Drag and drop images or documents, paste from the clipboard, or enter a URL.",
    "additionalLanguageHint": "System instruction, temperature, tokens, and reasoning",
    "attachmentUrl": "Attachment URL",
    "remoteAttachment": "Remote resource",
    "attachmentImage": "Image analysis",
    "attachmentPdf": "PDF document",
    "attachmentAudio": "Audio input",
    "attachmentsMessages": "Images and PDFs supported. Choose, drop, or paste a file, or enter a URL.",
    "attachmentsGemini": "Images, PDFs, audio, and video supported. Choose, drop, or paste a file, or enter a URL.",
    "attachmentsImages": "Images supported. Choose, drop, or paste a file, or enter a URL.",
    "reasoningSummary": "Show reasoning summary",
    "enableReasoning": "Enable reasoning",
    "adaptiveThinkingHint": "Enable adaptive reasoning and return a summary. When unchecked, keep the request's current thinking mode.",
    "effortField": "Reasoning effort ({{field}})",
    "reasoningTokenBudget": "Reasoning token budget",
    "tokenCount": "{{value}} tokens",
    "maxOutputTokens": "Max output tokens",
    "omitTokenLimit": "Not set (omitted)",
    "adaptiveTokenLimit": "Includes reasoning and response text, up to {{value}} tokens.",
    "outputTokenHint": "Sets the output limit for this request only. Context limits depend on the model.",
    "tokenRangeError": "Enter an integer from {{min}} to {{max}}.",
    "sellingPoints": "Highlights",
    "inputMode": {
      "text-to-video": "Text to video",
      "image-to-video": "Image to video",
      "video-to-video": "Video reference",
      "audio-to-video": "Audio reference",
      "text-to-image": "Text to image",
      "image-to-image": "Image to image",
      "text-to-audio": "Text to audio",
      "audio-to-audio": "Audio edit",
      "text-to-text": "Text generation"
    },
    "feature": {
      "max-duration-30s": "Up to 30s",
      "multimodal-reference": "Image, video, and audio references"
    },
    "clearAll": "Clear",
    "appendPhotos": "Add photos",
    "chooseOneImage": "Choose one reference image",
    "batchImagesHint": "Select multiple images (up to {{count}})",
    "maxImages": "Up to {{count}} images",
    "uploadingCloud": "Uploading…",
    "editMask": "Edit mask",
    "countFraction": "{{count}}/{{max}}",
    "addMoreShort": "Add",
    "addAudioCount": "Add audio ({{count}}/{{max}})",
    "addVideoCount": "Add video ({{count}}/{{max}})",
    "mediaReady": "Ready",
    "maskNeedsImage": "Add an input image when using a mask."
  },
  "admin": {
    "navAria": "Admin",
    "groups": {
      "overview": "Overview",
      "supply": "Models & supply",
      "commercial": "Commercial",
      "demand": "Demand",
      "observe": "Observability"
    },
    "links": {
      "overview": "Operations",
      "models": "Models",
      "channels": "Channels",
      "pricingPolicy": "Pricing management",
      "modelPrices": "Price reference",
      "wallets": "Wallets",
      "users": "Users",
      "usage": "Usage",
      "finance": "Financial statistics",
      "usageExports": "Exports",
      "requests": "Requests",
      "errors": "Errors"
    },
    "mobileNav": "Admin · {{section}}",
    "shell": {
      "backToSite": "Back to site",
      "signInRequiredTitle": "Sign in required",
      "signInRequiredDetail": "Sign in to access the admin console.",
      "forbiddenTitle": "No admin access",
      "forbiddenDetail": "This account does not have admin access. Sign in with an administrator account."
    }
  },
  "modality": {
    "language": "Language",
    "image": "Image",
    "video": "Video",
    "audio": "Audio",
    "world": "World",
    "embedding": "Embedding",
    "reranker": "Reranker",
    "multimodal": "Multimodal",
    "other": "Other"
  },
  "status": {
    "error": "Error",
    "warning": "Warning",
    "unknown": "Unknown",
    "active": "Active",
    "disabled": "Disabled",
    "archived": "Archived",
    "healthy": "Healthy",
    "degraded": "Degraded",
    "unavailable": "Upstream unavailable",
    "invalid": "Invalid",
    "ready": "Ready",
    "pending_configuration": "Probe not configured",
    "route_disabled": "Route disabled",
    "requires_task_endpoint": "Task endpoint required for probing",
    "missing_price": "Channel cost price missing",
    "invalid_price": "Invalid channel cost price",
    "missing_usage_ceiling": "Usage ceiling missing",
    "single_probe_budget_exceeded": "Single probe budget exceeded",
    "unknown_cost": "Cost unresolved; probing paused",
    "budget_exceeded": "Probe cost exceeded budget",
    "public": "Public",
    "private": "Private",
    "draft": "Draft",
    "published": "Published",
    "retired": "Retired",
    "pending": "Pending",
    "queued": "Queued",
    "running": "Running",
    "succeeded": "Succeeded",
    "first_response": "First response",
    "delivery_failed": "Storage failed",
    "failed": "Failed",
    "rejected": "Rejected",
    "cancelled": "Cancelled",
    "accepted": "Accepted",
    "received": "Received",
    "delivered": "Delivered",
    "retrying": "Retrying",
    "expired": "Expired",
    "revoked": "Revoked",
    "verified": "Verified",
    "needs_correction": "Needs correction",
    "durable": "Persisted",
    "temporary": "Temporary",
    "cancelling": "Cancelling",
    "canceled": "Cancelled",
    "submitted": "Submitted",
    "processing": "Processing",
    "polling": "Polling",
    "uploading": "Uploading",
    "completed": "Completed",
    "storing": "Persisting",
    "persisted": "Persisted",
    "unlisted": "Unlisted",
    "deprecated": "Deprecated",
    "needs route": "Needs route",
    "live": "Live",
    "verification_required": "Verification required"
  },
  "pricing": {
    "fps_band": "Source frame rate",
    "cache_creation_5m_input_tokens": "Cache write tokens (5 minutes)",
    "cache_creation_1h_input_tokens": "Cache write tokens (1 hour)",
    "cache_read_input_tokens": "Cache read tokens",
    "input_utf8_bytes": "Input UTF-8 bytes",
    "provider_credits": "Provider credits",
    "web_search_requests": "Web search",
    "unitTokens": "tokens",
    "unitBytes": "bytes",
    "unitCredits": "credits",
    "input_token_tier": "Input token tier",
    "audio": "Audio",
    "video": "Video",
    "cached_input_tokens": "Cached input",
    "cache_write_tokens": "Cache write",
    "input_tokens": "Input tokens",
    "output_tokens": "Output tokens",
    "input_images": "Image input",
    "output_images": "Image output",
    "input_video_seconds": "Video input",
    "output_video_seconds": "Video output",
    "input_audio_seconds": "Audio input",
    "output_audio_seconds": "Audio output",
    "input_characters": "Input characters",
    "requests": "Requests",
    "unitImages": "images",
    "unitSeconds": "sec",
    "unitCharacters": "chars",
    "unitRequests": "calls",
    "videoOutputTokens": "Video output tokens (vendor billing unit)",
    "perMillionVideoTokens": "per 1M video output tokens",
    "videoGenerate": "Video generation",
    "imageGenerate": "Image generation",
    "audioGenerate": "Audio generation",
    "general": "General",
    "modality": "Modality",
    "quality": "Quality",
    "region_scope": "Region scope",
    "resolution": "Resolution",
    "size": "Size",
    "has_input_video": "Has input video",
    "inputVideoLongerThanOutput": "Input duration > output duration",
    "inputVideoNotLongerThanOutput": "Input duration ≤ output duration",
    "speed": "Speed",
    "inference_geo": "Inference region",
    "global": "Global",
    "hd": "HD",
    "image": "Image",
    "non_global": "Non-global",
    "standard": "Standard",
    "fast": "Fast",
    "text": "Text",
    "us": "US",
    "eu": "EU",
    "tieredTitle": "Pricing and tiers",
    "currencyLabel": "Billing currency",
    "metricLabel": "Billing metric",
    "tierLabel": "Conditions / specifications",
    "saleLabel": "Price",
    "perUnit": "Per {{unit}}",
    "baseRate": "Standard rate",
    "unpublished": "Pricing is not published yet"
  },
  "fields": {
    "element_name": "Element name",
    "element_description": "Element description",
    "reference_type": "Element source type",
    "element_image_list": "Element images",
    "element_video_list": "Element videos",
    "element_voice_id": "Associated voice ID",
    "element_id": "Element ID",
    "tag_list": "Tags",
    "voice_name": "Voice name",
    "voice_url": "Audio URL",
    "video_id": "Source video ID",
    "timestamp": "Timestamp (seconds)",
    "prompt": "Prompt",
    "texts": "Prompt",
    "text": "Text",
    "input": "Input",
    "instructions": "Instructions",
    "images": "Reference images",
    "image": "Reference image",
    "imageUrl": "Reference image",
    "imageTail": "Last frame image",
    "modelH23TaskInput": "H23 task parameters",
    "modelH23FTaskInput": "H23F task parameters",
    "modelP55TaskInput": "P5.5 task parameters",
    "headtailImages": "First and last frames",
    "headImage": "First frame",
    "tailImage": "Last frame",
    "negativePrompt": "Negative prompt",
    "aspectRatio": "Aspect ratio",
    "motionMode": "Motion mode",
    "soundEffectSwitch": "Sound effects",
    "generateAudioSwitch": "Generate audio",
    "generateMultiClipSwitch": "Generate multiple clips",
    "thinkingType": "Prompt optimization",
    "promptOptimizer": "Optimize prompt",
    "fastPretreatment": "Fast preprocessing",
    "aigcWatermark": "AIGC watermark",
    "mask": "Edit mask",
    "videos": "Videos",
    "video": "Video",
    "audios": "Audios",
    "audio": "Audio",
    "files": "Files",
    "duration": "Duration",
    "resolution": "Resolution",
    "ratio": "Aspect ratio",
    "aspect_ratio": "Aspect ratio",
    "width": "Width",
    "height": "Height",
    "seed": "Seed",
    "voice_id": "Voice",
    "voice": "Voice",
    "speed": "Speed",
    "language": "Language",
    "negative_prompt": "Negative prompt",
    "with_audio": "Generate audio",
    "generate_audio": "Generate audio",
    "watermark": "Watermark",
    "temperature": "Temperature",
    "thinking": "Thinking",
    "output_config": "Output config",
    "top_k": "Top K",
    "stop_sequences": "Stop sequences",
    "top_p": "Top P",
    "reasoning_effort": "Reasoning effort",
    "max_output_tokens": "Max output tokens",
    "response_format": "Response format",
    "audio_format": "Audio format",
    "background": "Background",
    "channel": "Channel",
    "contents": "Content",
    "content": "Content",
    "dimensions": "Dimensions",
    "effort": "Effort",
    "emotion": "Emotion",
    "enable_prompt_cache": "Enable prompt cache",
    "enable_web_search": "Enable web search",
    "execution_expires_after": "Task expiry",
    "function_calling_config": "Function calling",
    "generate_count": "Generate count",
    "hd": "HD mode",
    "image_detail": "Image detail",
    "instrumental": "Instrumental",
    "is_stream": "Streaming",
    "is_thinking": "Thinking",
    "layer_decomposition": "Layer decomposition",
    "lyrics": "Lyrics",
    "lyrics_optimizer": "Lyrics optimizer",
    "max_tokens": "Max tokens",
    "moderation": "Moderation",
    "optimize_prompt_mode": "Prompt optimize mode",
    "output_compression": "Output compression",
    "output_format": "Output format",
    "apply_text_normalization": "Text normalization",
    "result": "Result",
    "pitch": "Pitch",
    "previous_response_id": "Previous response ID",
    "priority": "Priority",
    "prompt_cache_key": "Prompt cache key",
    "quality": "Quality",
    "reasoning_mode": "Reasoning mode",
    "safety_identifier": "Safety identifier",
    "service_tier": "Service tier",
    "sparse_embedding": "Sparse embedding",
    "store": "Store response",
    "system": "System instruction",
    "thinking_level": "Thinking level",
    "tool_config": "Tool config",
    "tools": "Tools",
    "model": "Model ID",
    "messages": "Messages",
    "stream": "Streaming",
    "generationConfig": "Generation settings",
    "systemInstruction": "System instruction",
    "thinkingConfig": "Thinking settings",
    "thinkingLevel": "Thinking level",
    "includeThoughts": "Include thoughts",
    "maxOutputTokens": "Max output tokens",
    "max_completion_tokens": "Max output tokens",
    "tool_choice": "Tool choice",
    "metadata": "Metadata",
    "url": "URL",
    "assetId": "Asset ID",
    "role": "Role",
    "embeddings": "Embeddings",
    "data": "Data",
    "verbosity": "Verbosity",
    "vol": "Volume",
    "size": "Size",
    "n": "Count",
    "callback_url": "Callback URL",
    "camera_motion": "Camera motion",
    "camera_fixed": "Fixed camera",
    "parameters": "Generation parameters",
    "output": "Generated output",
    "input_format": "Audio format",
    "punctuate": "Punctuation",
    "diarize": "Speaker separation",
    "timestamps": "Sentence timestamps"
  },
  "options": {
    "image_refer": "Images",
    "video_refer": "Video",
    "auto": "Auto",
    "adaptive": "Auto",
    "true": "Yes",
    "false": "No",
    "low": "Low",
    "medium": "Medium",
    "high": "High",
    "xhigh": "Extra high",
    "none": "None",
    "default": "Default",
    "standard": "Standard",
    "fast": "Fast",
    "normal": "Normal",
    "max": "Max",
    "png": "PNG",
    "jpeg": "JPEG",
    "webp": "WebP",
    "mp4": "MP4",
    "mov": "MOV",
    "transparent": "Transparent",
    "opaque": "Opaque",
    "ratio_16_9": "Landscape",
    "ratio_9_16": "Portrait",
    "ratio_1_1": "Square",
    "ratio_4_3": "4:3",
    "ratio_3_4": "3:4",
    "ratio_21_9": "21:9",
    "ratio_3_2": "3:2",
    "ratio_2_3": "2:3",
    "ratio_4_5": "4:5",
    "ratio_5_4": "5:4",
    "ratio_9_21": "9:21"
  },
  "roles": {
    "middle_frame": "Middle frame",
    "keyframe": "Keyframe",
    "prompt": "Prompt",
    "negative_prompt": "Negative prompt",
    "script": "Script",
    "lyrics": "Lyrics",
    "source": "Source asset",
    "mask": "Mask",
    "control": "Control image",
    "voice_reference": "Voice reference",
    "subject": "Subject reference",
    "background": "Background reference",
    "edit": "Edit video",
    "extend": "Extend video",
    "first_frame": "First frame",
    "last_frame": "Last frame",
    "reference_image": "Reference image",
    "reference_video": "Reference video",
    "reference_audio": "Reference audio",
    "input": "Input",
    "output": "Output",
    "intermediate": "Intermediate",
    "preview": "Preview",
    "thumbnail": "Thumbnail",
    "reference": "Reference"
  },
  "workspace": {
    "expandFilters": "Expand",
    "collapseFilters": "Collapse",
    "resourceId": "Resource ID",
    "resourceReferenceHint": "Use a resource ID returned by the configured channel. Reference it in the prompt using @name.",
    "incompleteReference": "Enter {{fields}}, or remove this reference.",
    "resource_element": "Element reference",
    "resource_voice": "Voice reference",
    "referenceName": "Reference name",
    "partSource": "source",
    "partMoveUp": "Move content up",
    "partMoveDown": "Move content down",
    "partRemove": "Remove content",
    "viewOutputs": "View all {{count}} outputs →",
    "run": "Run",
    "running": "Running…",
    "reset": "Reset",
    "cancel": "Cancel",
    "save": "Save",
    "close": "Close",
    "copy": "Copy",
    "copied": "Copied",
    "refresh": "Refresh",
    "roleUnspecified": "Unspecified (use upstream behavior)",
    "retry": "Retry",
    "search": "Search",
    "clear": "Clear",
    "add": "Add",
    "remove": "Delete",
    "edit": "Edit",
    "maintain": "Manage",
    "done": "Done",
    "previous": "Previous",
    "next": "Next",
    "optional": "Optional",
    "optionalZh": "Optional",
    "confirm": "Confirm",
    "now": "Now",
    "clearValue": "Clear",
    "refreshList": "Refresh list",
    "closeToast": "Dismiss notification",
    "input": "Input",
    "output": "Output",
    "preview": "Preview",
    "form": "Form",
    "inputJson": "Input JSON",
    "inputMode": "Input view",
    "resultView": "Output view",
    "moreSettings": "More settings",
    "restore": "Restore defaults",
    "loadingParameters": "Loading parameters…",
    "loadingModelParameters": "Loading model parameters…",
    "loadingModel": "Loading model…",
    "loadingEndpoint": "Loading endpoint parameters…",
    "runResults": "Results",
    "textResults": "Text results",
    "title": "Playground",
    "operation": "Operation",
    "selectModels": "Models",
    "addModel": "Add model",
    "loginToRun": "Sign in to run",
    "repetitions": "Outputs per model",
    "searchResults": "Search results",
    "searchGenerations": "Generations…",
    "searchText": "Text requests…",
    "clearSearch": "Clear search",
    "runStatus": "Run status",
    "allStatus": "All statuses",
    "noText": "No text requests yet",
    "noRuns": "No runs yet",
    "noMatches": "No matching runs",
    "emptyText": "Select models and enter a prompt to compare their responses.",
    "runCard": "Run",
    "copyPrompt": "Copy prompt",
    "copyAnswer": "Copy answer",
    "copyReply": "Copy reply",
    "submitting": "Submitting",
    "requestFailed": "Request failed",
    "runFailed": "Request failed",
    "waiting": "Ready",
    "totalCost": "Total cost",
    "total": "Total",
    "duration": "Duration",
    "cost": "Cost",
    "status": "Status",
    "time": "Time",
    "tools": "Tools",
    "toolsMulti": "Tools (multiple selection)",
    "toolsUnavailable": "Not supported by this endpoint",
    "ping": "Connectivity test",
    "toolCall": "Model tool call",
    "toolResult": "Nexra tool result",
    "rawResponse": "Raw response",
    "toolArgs": "Arguments",
    "toolReturn": "Tool result",
    "images": "Images",
    "videos": "Videos",
    "audios": "Audio",
    "upload": "Upload",
    "prompt": "Prompt",
    "loading": "Loading…",
    "all": "All",
    "models": "Models",
    "channel": "Channel",
    "provider": "Provider",
    "protocol": "Endpoint protocol",
    "inputContent": "Input content",
    "role": "Asset role",
    "params": "Request parameters",
    "responseParams": "Response parameters",
    "apiKeys": "API keys",
    "requests": "Request history",
    "admin": "Administration",
    "account": "Account",
    "settings": "Settings",
    "usage": "Usage",
    "logout": "Sign out",
    "name": "Name",
    "createTime": "Created",
    "startTime": "Started",
    "endTime": "Completed",
    "callback": "Callback",
    "error": "Error",
    "enabled": "Enabled",
    "featured": "Featured",
    "public": "Public",
    "modelInfo": "Basic information",
    "protocols": "Protocols & parameters",
    "prices": "Pricing",
    "routes": "Channels & routing",
    "currency": "Currency",
    "description": "Description",
    "summary": "Summary",
    "displayName": "Display name",
    "developer": "Developer",
    "aliases": "Public aliases",
    "visibility": "Visibility",
    "modelState": "Model status",
    "publishedVersion": "Version",
    "inputOutput": "Input & output parameters",
    "requestHeaders": "Headers",
    "requestBody": "Request body",
    "pathParams": "Path parameters",
    "queryParams": "Query parameters",
    "requestExample": "Request example",
    "responseExample": "Response example",
    "noRequestBody": "No request body.",
    "schemaJson": "Schema JSON",
    "modelParams": "Model parameters",
    "fieldDefault": "Default",
    "viewAll": "View all",
    "openOriginal": "Open original file ↗",
    "copyJson": "Copy JSON",
    "example": "Example",
    "examplesNone": "No examples",
    "examplesNoneDetail": "No examples are available for this version.",
    "loadingRequest": "Running request…",
    "noModel": "Model not found",
    "selectPlaceholder": "Select…",
    "selectPlaceholderDots": "Select…",
    "apiDocs": "API documentation",
    "price": "Pricing",
    "history": "Request history",
    "date": "Date",
    "defaultHint": "Default",
    "query": "Query",
    "filter": "Filter",
    "resetFilters": "Reset filters",
    "loadingChannels": "Loading channels…",
    "noPage": "Page not found",
    "deleted": "Deleted",
    "noData": "No data",
    "copyId": "Copy ID",
    "copyCode": "Copy code",
    "startGeneration": "Generate",
    "generating": "Generating…",
    "closeSearch": "Clear input",
    "emptyMenu": "No matching options",
    "loadingListError": "Unable to load the list. Please retry.",
    "noOptions": "No matching options. Try another search.",
    "scrollUp": "Scroll options up",
    "scrollDown": "Scroll options down",
    "uploaded": "Uploading assets…",
    "costUnknown": "Cost unavailable",
    "requestId": "Request ID",
    "taskId": "Task ID",
    "noRequests": "No requests yet",
    "searchRequests": "Search requests",
    "loadingMore": "Load more requests",
    "loadingStats": "Load more samples",
    "originalFile": "Open original file in a new tab",
    "newRequest": "Send request",
    "submitTask": "Submit task",
    "taskLifecycle": "Task lifecycle",
    "files": "Files",
    "client": "Client setup",
    "toc": "On this page",
    "dateSnapshot": "Snapshots",
    "requestResponse": "Request & response parameters",
    "language": "Example language",
    "apiCall": "API usage",
    "snapshots": "Snapshot versions",
    "useExample": "Use in Playground",
    "requestLayout": "Request layout",
    "refreshData": "Refresh data",
    "filterType": "Filter by type",
    "noMatchingRequests": "No matching requests",
    "searchRequestsHint": "Request ID, model, prompt, end user or source/IP…",
    "searchRuns": "Search runs",
    "noRunRecords": "No runs",
    "noRunRecordsDetail": "Start a run in the playground, or adjust the filters.",
    "signIn": "Sign in",
    "needSignIn": "Sign in to continue",
    "progress": "Progress",
    "completed": "Succeeded",
    "recommended": "Recommended",
    "action": "Actions",
    "modelPool": "Upstreams & routing",
    "queryResponse": "Query response",
    "resultContent": "Generated content",
    "messageList": "Messages",
    "generationParams": "Generation parameters",
    "comboLimits": "Combination limits",
    "loadingPricing": "Loading pricing policy…",
    "enable": "Enabled",
    "costPrice": "Cost price",
    "priority": "Weight",
    "main": "Primary",
    "endpoint": "Public endpoints",
    "noEndpoint": "No public endpoints",
    "lifecycle": "Lifecycle",
    "modelType": "Model type",
    "connection": "Connection status",
    "channelStatus": "Channel status",
    "currentModel": "Current model",
    "availableModels": "Available models",
    "recentErrors": "Recent errors",
    "basicInfo": "Basic information",
    "pricingRules": "Pricing rules",
    "billingUnit": "Billing unit",
    "unitPrice": "Unit price",
    "condition": "Condition",
    "dimensions": "Dimension",
    "value": "Value",
    "copyMarkdown": "Copy Markdown",
    "requestDetails": "Request details",
    "characterCount": "{{count}} characters",
    "promptPlaceholder": "Enter a prompt…",
    "shortcut": "Shortcut",
    "collapse": "Less",
    "send": "Send",
    "dateTimeInvalid": "Enter a valid date and time: YYYY-MM-DD HH:mm",
    "selectDate": "Select {{label}}",
    "dateCalendar": "{{label}} calendar",
    "hours": "Hours",
    "minutes": "Minutes",
    "part_text": "Text",
    "part_image": "Image",
    "part_video": "Video",
    "part_audio": "Audio",
    "part_draft_task": "Draft task",
    "partOrderHint": "Add content in order; use the arrows to reorder it.",
    "partRoleOrderHint": "Add content in order; adjust the order and each reference's role.",
    "partArrayHint": "Content must be an array. Edit it in JSON.",
    "partUnsupportedHint": "Edit this content type in JSON.",
    "partTextLabel": "Text content {{index}}",
    "partTextPlaceholder": "Describe the scene, action and sound…",
    "partEditTextPlaceholder": "Enter a prompt or editing instructions…",
    "partSourceLabel": "Media source",
    "partOther": "Other content",
    "partMediaHint": "Use a public URL, a full data: Base64 URL, or an upstream media locator."
  },
  "sandbox": {
    "inputMediaTooLarge": "Video inputs uploaded as HTTP URLs must not exceed {{maxMb}} MB. Compress the video or use a supported Google Cloud Storage URI.",
    "randomModel": "Random model",
    "searchOperations": "Search operations",
    "category": "Category",
    "operation": "Operation",
    "noOperations": "No matching operations",
    "modelCount": "{{count}} runnable models",
    "selectedCount": "{{count}} selected",
    "runSummary": "{{models}} models × {{repetitions}} runs",
    "searchModels": "Search {{category}} models",
    "noModels": "No matching {{category}} models",
    "noAvailableModels": "No models available to try",
    "chooseModel": "Add a model to enter parameters",
    "maxModels": "Up to {{count}} models",
    "browseModels": "Browse models",
    "removeModel": "Remove {{model}}",
    "toolsCount": "{{count}} enabled",
    "pingTag": "Connectivity test",
    "pingDescription": "Verify tool calling with an echo tool",
    "builtinTool": "Built-in tool",
    "builtinToolDescription": "Provide tool definitions to enable tool calling",
    "singleHistory": "Individual request history ({{count}})",
    "changeFilters": "Try a different search or status filter.",
    "textCategory": "Text",
    "backToMediaLibrary": "Back to all creations",
    "loadingOlderCreations": "Loading earlier creations…",
    "retryMediaHistory": "Retry loading history",
    "loadOlderCreations": "Load earlier creations",
    "allMediaHistoryLoaded": "All {{category}} history loaded",
    "audioDuration": "Audio duration",
    "durationNotRecorded": "Duration not recorded",
    "noReferenceInput": "This operation has no reference input. Enter your content to get started.",
    "videoWelcomeTitle": "Set your imagination in motion",
    "videoWelcomeDescription": "Describe the scene, motion and sound. Bring your ideas to video.",
    "backToCreation": "Back to current creation",
    "backToVideoLibrary": "Back to all creations",
    "promptAndSettings": "Prompt and full settings",
    "loadOlderVideos": "Load earlier creations",
    "loadingOlderVideos": "Loading earlier creations…",
    "retryVideoHistory": "Retry loading history",
    "allVideoHistoryLoaded": "All video history loaded",
    "horizontalHistoryHint": "Browse horizontally. Current session results come first; past records open for viewing.",
    "previousCreation": "Browse creations to the left",
    "nextCreation": "Browse creations to the right",
    "mediaRequestGroup": "Creation record: {{title}}",
    "currentSessionResult": "Current session",
    "historyRecord": "Past record",
    "createFromHistory": "Create from this record",
    "historyCreationTitle": "Start creating from this record?",
    "historyCreationDescription": "This is a past record. Confirming replaces your current draft with its prompt, original input references, models and parameters. Generated outputs are not added as references, and no request is sent yet. Selecting Generate creates an independent task and may incur new charges. The original record stays unchanged.",
    "historyCreationConfirm": "Confirm and load settings",
    "modelSpecificParametersHint": "Selected models share compatible parameters. Select a model on its own to configure the model-specific fields or options below.",
    "configureSingleModel": "Select this model to configure",
    "mediaWorkspaceTitle": "{{category}} creation",
    "mediaLibrary": "Past creations",
    "viewNamedConversation": "View conversation: {{title}}",
    "backToConversationHistory": "Back to past conversations",
    "backToCurrentConversation": "Back to current conversation",
    "conversationHistory": "Past conversations",
    "newShort": "New",
    "backToCreationShort": "Back",
    "currentCreations": "Current creation",
    "previewCreation": "Preview",
    "previewNamedCreation": "Preview creation: {{title}}",
    "reuseSettings": "Reuse settings",
    "previewKeepsDraft": "Previewing keeps your draft unchanged. Choose Reuse settings to edit and generate again below.",
    "replaceDraftTitle": "Load these creation settings?",
    "replaceDraftDescription": "The composer contains unsent content or custom settings. Loading replaces the prompt, original input assets, models and parameters. Generated creations are kept.",
    "replaceDraftConfirm": "Replace draft and load",
    "noMediaHistory": "No {{category}} creations yet",
    "mediaLibraryEmptyHint": "Start creating below. Saved creations appear here for previewing or reusing settings.",
    "outputCount": "{{count}} results",
    "newGeneration": "New creation",
    "untitledGeneration": "Untitled creation",
    "mediaWelcome": {
      "image": "What would you like to create?",
      "video": "What video would you like to create?",
      "audio": "What would you like to hear?"
    },
    "mediaWelcomeDescription": "Choose an operation and models, enter your content, and start creating.",
    "mediaPrompt": {
      "image": "Describe an image or explain the edits you want…",
      "video": "Describe the scene, motion and sound, and add references as needed…",
      "audio": "Enter a script or describe the music or sound effects you want…"
    },
    "readingGeneration": "Viewing a past creation",
    "generateFromRecord": "Generate with these settings",
    "mediaRunSummary": "{{count}} models × {{repetitions}} runs",
    "outputNumber": "Output {{count}}",
    "untitledConversation": "Untitled conversation",
    "historyDay": {
      "today": "Today",
      "yesterday": "Yesterday",
      "earlier": "Earlier"
    },
    "historyRounds": "{{count}} turns",
    "historySingleRequest": "Single request",
    "readingHistory": "Viewing a past conversation",
    "resumeConversation": "Continue this conversation",
    "startFromRecord": "Start a conversation from this record",
    "rawRecord": "Original request and response",
    "loadingSavedReply": "Loading the saved response…",
    "savedReplyUnavailable": "Full details are unavailable. Reopen this record to try again.",
    "replyNotRecorded": "The response body was not saved for this record. Request details contain the available information.",
    "replyUnrecognized": "This record contains response data, but no readable text could be extracted. View the original response.",
    "questionNotRecorded": "No user question could be identified in this record. View the original input.",
    "showHistory": "Show history sidebar",
    "hideHistory": "Hide history sidebar",
    "conversationList": "Conversation history",
    "recentConversations": "Recent conversations",
    "parameterShortcut": "Parameters",
    "historyModelsUnavailable": "This conversation includes unavailable models. Adjust the selection to start a new conversation.",
    "addTextPart": "Add text segment",
    "editContentInJson": "Edit this content through More → JSON.",
    "moreActions": "More actions",
    "customParameters": "Custom parameters applied",
    "currentSession": "Conversations from this visit",
    "welcomeTitle": "What would you like to explore?",
    "welcomeDescription": "Choose your models, write a message, and start a conversation.",
    "promptPlaceholder": "Ask a question or describe what you want to do…",
    "continuePlaceholder": "Ask a follow-up…",
    "chooseChatModel": "Choose one or more models to start a conversation.",
    "checkParameters": "Check the input format in parameters.",
    "requestDetails": "Request details",
    "backToConversation": "Back to current chat",
    "initialContext": "Initial conversation context (optional)",
    "toolsSettings": "Tool settings",
    "historyComposerHint": "The input below still sends to the current chat",
    "historyReplyHint": "Follow-ups in this record continue this historical conversation only.",
    "tokenDetailsHint": "Click for full token and turn details",
    "newConversation": "New conversation",
    "history": "History",
    "parameters": "Parameters",
    "sharedInput": "Shared input",
    "sendToModels": "Send to {{count}} models",
    "followUpTarget": "Send follow-up to",
    "followUpAll": "All models ({{count}})",
    "followUpSelected": "Follow-up target",
    "continueConversation": "Continue conversation",
    "singleConversation": "Conversation",
    "send": "Send",
    "waitingResponse": "Waiting for response",
    "elapsedSeconds": "{{seconds}}s",
    "submittingTask": "Submitting task",
    "queuedTask": "Queued",
    "generatingTask": "Generating",
    "jsonInComposer": "Edit the complete JSON in the shared input below.",
    "emptyConversation": "Enter a prompt below to start a conversation or compare models.",
    "contextPanel": "Context",
    "hideContext": "Hide context",
    "showContext": "Show context",
    "readingModel": "Reading model: slot {{slot}}",
    "manageModels": "Participating models",
    "generationBatch": "Generation batch",
    "batchLabel": "Batch {{count}} · {{time}}",
    "sendTo": "Send to",
    "targetHiddenLocate": "Target hidden · Locate",
    "askThisModel": "Ask this model",
    "askModel": "Ask {{model}}",
    "expandPrompt": "Show full prompt",
    "collapsePrompt": "Collapse prompt",
    "completedModels": "Completed",
    "cumulativeDuration": "Combined model time",
    "hiddenTargetLabel": "Hidden · {{model}}"
  },
  "operations": {
    "video-depth": "Video depth extraction",
    "video-segment": "Video object segmentation",
    "image-upscale": "Image upscale",
    "video-upscale": "Video upscale",
    "voice-create": "Save voice",
    "voice-clone": "Clone voice",
    "language-generate": "Text generation",
    "image-generate": "Image generation",
    "video-generate": "Video generation",
    "audio-generate": "Audio generation",
    "world-generate": "World generation",
    "embedding-create": "Embedding generation",
    "text-to-image": "Text to image",
    "image-to-image": "Image to image",
    "edit-image": "Image editing",
    "edit-multi-images": "Multi-image editing",
    "upscale": "Upscale",
    "remove-background": "Remove background",
    "avatar-video": "Avatar video",
    "multimodal-to-video": "Multimodal reference",
    "text-to-video": "Text to video",
    "image-to-video": "First & last frame to video",
    "audio-to-video": "Audio to video",
    "video-to-video": "Video to video",
    "text-to-speech": "Text to speech",
    "text-to-music": "Music generation",
    "text-to-sfx": "Sound effect generation",
    "text-to-audio": "Sound generation",
    "speech-to-text": "Speech to text",
    "text-to-world": "Text to world",
    "image-to-world": "Image to world",
    "video-to-world": "Video to world",
    "text-to-text": "Chat",
    "multimodal-to-text": "Multimodal chat",
    "audio-transcribe": "Speech recognition",
    "audio-to-text": "Speech to text"
  },
  "timing": {
    "invalidRecord": "Missing timing record or invalid timestamps",
    "activeTask": "Timing from task submission, including queue time",
    "activeTaskAcceptance": "Timing from task submission, including queue time; request acceptance took {{duration}}",
    "taskAcceptance": "Total task duration; request acceptance took {{duration}}{{missing}}",
    "unfinishedOrMissing": "; task unfinished or timing record missing",
    "apiRequest": "API request duration",
    "title": "Timing",
    "liveLabel": "Live task duration",
    "total": "Total duration",
    "deploymentCorrection": "Output ready in {{service}}; deployment added {{delay}}. Total duration retains the actual response time.",
    "request": "Request duration",
    "prep": "Preparation",
    "gen": "Generation",
    "stor": "Storage",
    "stages": "{{count}}-stage timing",
    "responseOverhead": "Other processing/waiting",
    "responseOverheadHint": "Not separately instrumented; the difference between the first response and recorded stages.",
    "api": "API request",
    "queuedHint": "Queueing and checking the task…",
    "prepTask": "Queueing and task checks",
    "prepApi": "Authentication and routing",
    "generatingHint": "The model is generating…",
    "genTask": "Model inference",
    "genApi": "Streaming model response",
    "storingHint": "Saving generated media…",
    "storTask": "Saving generated media",
    "storApi": "Request logging and billing",
    "response": "Response",
    "firstResponse": "First response",
    "secondResponse": "Second response",
    "incomplete": "Stage records are missing or out of order; total duration is measured from submission to completion.",
    "liveDetail": "Task running; elapsed: {{duration}}",
    "stageDetail": "{{stage}}: {{duration}}",
    "apiDetail": "API request duration",
    "stageShare": "{{stage}} {{duration}} ({{percent}}%)"
  },
  "channelMapping": {
    "channelDisabled": "Channel disabled",
    "supplyDisabled": "Supply disabled",
    "degraded": "Channel degraded",
    "unavailable": "Upstream unavailable",
    "active": "Supply enabled"
  },
  "modelDelivery": {
    "help": "Map upstream channel models to this model, then configure each public endpoint’s routes, priorities, weights and status.",
    "addSupply": "+ Add supply",
    "overview": "Route overview",
    "overviewHelp": "Review protocol coverage, primary and backup routes, and weights for each channel.",
    "summary": "{{providers}} providers · {{supplies}} supplies · {{count}} schedulable combinations for current protocols",
    "noCoverage": " (no available coverage)",
    "matrix": "Endpoint coverage matrix",
    "supplies": "Back to channel list"
  },
  "privateVoices": {
    "cloneTitle": "Clone a private voice",
    "samples": "Audio samples",
    "sampleLimit": "Select 1–5 audio files, totaling at most 25 MiB.",
    "slotPrice": "{{amount}} for a 30-day voice slot.",
    "clone": "Clone voice",
    "cloning": "Cloning…",
    "cloneFailed": "Could not clone the voice."
  },
  "userUsage": {
    "description": "All calls and settled spending for this account in the selected window, including API keys and Playground. Filtered by request receipt time; days are grouped in UTC.",
    "start": "Start time",
    "end": "End time",
    "recentDays": "Last {{count}} days",
    "recentDays_one": "Last {{count}} day",
    "invalidRange": "Choose a valid start and end time, no more than 31 days apart.",
    "allRequests": "All calls, not a sample",
    "settledCharges": "Settled spending",
    "settledHint": "Successful settlements only; refunded charges excluded",
    "noSettledCharges": "No settled charges",
    "successHint": "Successful requests as a share of all requests",
    "unsettledHint": "Requests with usage awaiting settlement",
    "dayUtc": "Date (UTC)",
    "distributionHint": "All requests by model within the selected time window."
  },
  "creativeHome": {
    "footer": {
      "creation": "Create and explore",
      "models": "Model categories",
      "developer": "Developers and account",
      "about": "About Nexra",
      "audioModels": "Audio models",
      "usage": "Usage statistics"
    },
    "revealPhotos": {
      "cloud-city": "Cloud city",
      "three-color-city": "Three-color city",
      "icefield-moons": "Two moons over an icefield",
      "bionic-architecture": "Bionic ecological architecture",
      "cloud-goldfish": "Goldfish in the clouds",
      "inverted-salt-lake": "Inverted salt lake",
      "liquid-stars": "Liquid starry sky",
      "winter-forest": "Winter forest",
      "glass-city": "Glass city",
      "sunflower-observatory": "Sunflower observatory",
      "underwater": "Underwater",
      "candy-shelves": "Candy shelves",
      "inverted-sea": "Inverted sea",
      "alien-plants": "Alien plants",
      "floating-island": "Floating island",
      "geometric-city": "Geometric future city",
      "van-gogh": "Van Gogh",
      "mirror": "Mirror",
      "strange-object": "Strange object",
      "colorful-banana": "Colorful banana",
      "crystal-spires": "Crystal spires",
      "flowing-light-city": "City of flowing light",
      "clay": "Clay",
      "flying-bookshop": "The old bookshop takes flight"
    },
    "galleries": {
      "videoEyebrow": "SELECTED FILMS",
      "videoTitle": "More possibilities in motion",
      "videoDescription": "Product films, character reveals and expressive visuals. Expand a film to see the details.",
      "pauseVideo": "Pause video",
      "playVideo": "Play video",
      "imageEyebrow": "VISUAL INSPIRATION",
      "imageTitle": "One idea. Many expressions.",
      "imageDescription": "Explore commercial design, cinematic scenes, character studies and portraits full of life.",
      "pauseWall": "Pause motion",
      "playWall": "Resume motion",
      "wallHint": "Select an image to view it in full",
      "modelsTitle": "More models for every idea",
      "modelsDescription": "Explore video, image, audio and language models through Nexra. Find the capabilities for your products and creative work.",
      "videos": {
        "v9": {
          "title": "Product films",
          "description": "Materials, light and camera movement put the product in focus."
        },
        "v13": {
          "title": "Time and motion",
          "description": "Freeze a moment and explore it from another angle."
        },
        "v11": {
          "title": "Character reveals",
          "description": "Bring character design and atmosphere together in a cinematic entrance."
        },
        "v14": {
          "title": "Pop visuals",
          "description": "Characters, graphics and fast-paced edits create visual energy."
        },
        "v16": {
          "title": "Stylized films",
          "description": "Distinctive color and dynamic composition give each film its own voice."
        }
      },
      "images": {
        "p10": "Fashion cover",
        "p30": "Portrait in the sun",
        "p14": "Neon anime",
        "p24": "Color comic storyboard",
        "p16": "Product through paper",
        "p27": "Bamboo forest cinema",
        "p25-character": "Character study and views",
        "p31": "A moment in the meadow",
        "p18": "Drink campaign",
        "p13": "Rainy anime streets",
        "p26": "Fantasy cinema",
        "p23": "Pop character design",
        "p20": "Dark fantasy world",
        "p29": "Street portrait",
        "p25-comic": "Black-and-white comic",
        "p15": "Street delivery",
        "p22-eastern": "Eastern landscapes",
        "p17": "Food campaign",
        "p28": "Snowy cinematic portrait",
        "p22-pop": "Purple pop visuals"
      }
    },
    "announcement": {
      "label": "Discover Nexra",
      "message": "From one idea to more creative possibilities. Explore video, image and text creation with Nexra.",
      "about": "Discover Nexra",
      "contact": "Get in touch"
    },
    "info": {
      "preparing": "Coming soon",
      "back": "Back to home",
      "about": {
        "title": "Discover Nexra",
        "description": "This page will introduce Nexra’s creative capabilities and how to use them. Content is being prepared."
      },
      "contact": {
        "title": "Get in touch",
        "description": "Partnership details and contact information will be available here. Content is being prepared."
      }
    },
    "playground": "Playground",
    "modelSquare": "Models",
    "heroLabel": "Creative introduction and featured video",
    "heroTitle": "Imagine it\nBring it to life",
    "heroDescription": "Video, images and words come together\nStart with an idea. Explore where it takes you",
    "start": "Start creating",
    "discover": "Explore work",
    "videoTitle": "From product films to character stories",
    "videoDescription": "Show products through cinematography and bring characters to life through motion",
    "audioNote": "Muted by default · Click to enable sound, hover to listen, leave to mute · Enter / Space toggles sound",
    "mediaError": "This video could not be played. Refresh the page to try again.",
    "imageRevealOpeningTitle": "Discover more\ncreative possibilities",
    "imageRevealTitle": "Let inspiration\ncome to life",
    "imageTitle": "Scenes, design and portraits",
    "filterLabel": "Filter images",
    "filters": {
      "all": "All",
      "scene": "Scenes",
      "design": "Design",
      "portrait": "Portraits"
    },
    "groups": {
      "scene": {
        "title": "Scenes and spaces"
      },
      "design": {
        "title": "Posters and design"
      },
      "portrait": {
        "title": "Portraits and styles"
      }
    },
    "viewImage": "View the full image: {{title}}",
    "exploreText": "Explore text models",
    "scriptLabel": "Storyboard draft",
    "example": "Example content",
    "scriptPrompt": "Create a 15-second ad for a compact camera\nHighlight its materials, lens and portable body",
    "scriptAnswer": "0–5 seconds · Detail\nSide lighting sweeps across the body as the camera moves into the metal texture\n\n5–10 seconds · Transition\nMove through the lens, matching reflections in the glass to ripples on water\n\n10–15 seconds · Product\nThe camera turns toward the viewer and holds on the complete body",
    "modelTitle": "Explore models by creative task",
    "models": {
      "video": {
        "title": "Video models",
        "description": "Motion, cinematography and storytelling"
      },
      "image": {
        "title": "Image models",
        "description": "Composition, style and detail"
      },
      "language": {
        "title": "Text models",
        "description": "Understanding, expression and ideas"
      }
    },
    "ending": "Start your next creation",
    "exploreCreate": "Start creating",
    "backTop": "Back to top",
    "media": {
      "v1": {
        "title": "A story in the ancient hall",
        "type": "Storytelling · V1",
        "alt": "A character-driven scene in an ancient hall"
      },
      "v2": {
        "title": "Imagination in the storm",
        "type": "Fantasy · V2",
        "alt": "A stormy ocean and a fantastical figure"
      },
      "v6": {
        "title": "When the light falls",
        "type": "Close-up · V6",
        "alt": "A close-up portrait in warm light"
      },
      "v4": {
        "title": "The other side of the city",
        "type": "Close-up · V4",
        "alt": "A close-up against a city at night"
      },
      "v8": {
        "title": "Tracking shot",
        "type": "Cinematic mood · V8",
        "alt": "A character in a warmly lit corridor"
      },
      "v5": {
        "title": "Action and tension",
        "type": "Action · V5",
        "alt": "An action scene with explosive effects"
      },
      "v7": {
        "title": "Another perspective",
        "type": "Performance · V7",
        "alt": "A character performance seen from below"
      },
      "p5": {
        "title": "City in the clouds",
        "alt": "A fantasy city at sunset with floating buildings and waterfalls"
      },
      "p6": {
        "title": "Water city at dusk",
        "alt": "A clock tower and city lights reflected in water at dusk"
      },
      "v3": {
        "title": "Chasing the sunset",
        "alt": "A sunset racetrack viewed from a racing cockpit"
      },
      "p1": {
        "title": "Blue composition",
        "alt": "A blue and white collage of geometric shapes and photographed hands"
      },
      "p3": {
        "title": "Know yourself",
        "alt": "A black and white profile poster with Chinese typography"
      },
      "p2": {
        "title": "Digital portrait",
        "alt": "A large portrait formed from colorful digital glitch blocks"
      },
      "p4": {
        "title": "Future light",
        "alt": "A futuristic mechanical profile with iridescent highlights on black"
      },
      "p8": {
        "title": "An everyday moment",
        "alt": "A woman in white patterned loungewear standing in a bedroom"
      },
      "p7": {
        "title": "Retro future",
        "alt": "A retro-futuristic collage of figures, fantasy creatures and architecture"
      },
      "p9": {
        "title": "Dreaming in landscapes",
        "alt": "A pale blue double exposure combining a woman's profile and a Chinese landscape"
      },
      "v9": {
        "title": "Product film",
        "alt": "A camera product film featuring its body, lens and material details"
      },
      "v10": {
        "title": "Character motion",
        "alt": "A vertical full-body dance video filmed outdoors"
      },
      "v11": {
        "title": "Character reveal",
        "alt": "A stylized 3D character reveal with yin-yang imagery"
      },
      "v12": {
        "title": "Product reveal",
        "alt": "A hand clears condensation from glass to reveal a product in a portrait video"
      },
      "v13": {
        "title": "Frozen time",
        "alt": "A camera orbits a person and suspended bottles in a frozen moment"
      }
    },
    "exploreVideo": "Explore video models",
    "exploreImage": "Explore image models"
  },
  "asr": {
    "mode": "Recognition mode",
    "sentence": "Sentence recognition",
    "realtime": "Real-time recognition",
    "maxSeconds": "Maximum input audio seconds",
    "captureFormat": "Microphone input: 16 kHz, 16 bit, mono PCM.",
    "unsupportedSampleRate": "This browser cannot capture audio at 16 kHz.",
    "connectionFailed": "Speech recognition disconnected or failed. Check request history.",
    "start": "Start recording",
    "stop": "Finish recording",
    "transcript": "Transcript",
    "listening": "Recognizing speech; interim text may change.",
    "firstMessage": "Initial WebSocket configuration message",
    "responseMessages": "WebSocket response messages"
  }
}
